<template>
  <div>
        <v-dialog v-model="dialog" max-width="450" persistent>
            <v-card>
                <v-card-title>
                    <span class="headline"> 図面番号入力 </span>
                    <v-spacer></v-spacer>
                    <v-icon dark @click="toggleDialogRevision(false)">mdi-close</v-icon>
                </v-card-title>
                <v-container>
                    <v-card-text>
                        <v-radio-group v-model="radio" dense > 
                            <!-- <v-radio :label="`新規CAD依頼(図面番号︓${possibleRevision})`" value="1"></v-radio> -->
                            <v-radio v-show="loggedInUser.is_hrd_requestor != 1" 
                                :disabled="cadRequestBasicInformation.kakouirai_reason == 1 || cadRequestBasicInformation.kakouirai_reason == 2 || cadRequestBasicInformation.house_type_id == 4 || cadRequestBasicInformation.house_type_id == 5 || cadRequestBasicInformation.house_type_id == 3 || cadRequestBasicInformation.house_type_id == 29 || cadRequestBasicInformation.house_type_id == 22" 
                                :label="`新規CAD依頼(図面番号︓${possibleRevision}`" value="1">
                            </v-radio>
                            <!-- <v-radio v-show="loggedInUser.is_hrd_requestor != 1" 
                                :disabled="cadRequestBasicInformation.kakouirai_reason == 1 || cadRequestBasicInformation.kakouirai_reason == 2 || cadRequestBasicInformation.house_type_id == 4 || cadRequestBasicInformation.house_type_id == 5" 
                                :label="`新規CAD依頼(図面番号︓${possibleRevision}`" value="1">
                            </v-radio> -->
                            <v-expand-transition>
                                <div class="pl-8" v-if="radio == 1">
                                    <form ref="APlan">
                                        <v-radio-group v-model="radio2" dense>
                                            <v-radio label="施工面積58坪未満" value="1A" name="more_than_58_tsubo"></v-radio>
                                            <v-radio label="施工面積58坪以上" value="1B" name="less_than_58_tsubo"></v-radio>
                                        </v-radio-group>
                                    </form>
                                </div>
                            </v-expand-transition>
                            
                            <v-radio v-show="loggedInUser.is_hrd_requestor != 1"  label="大きな変更あり(前回依頼分より)" value="2" :disabled="cadRequestBasicInformation.kakouirai_reason == 1 || cadRequestBasicInformation.kakouirai_reason == 2"></v-radio>
                            <v-expand-transition>
                                <div class="pl-8" v-if="radio == 2">
                                    <p class="caption font-weight-black" style="color: red !important;">・約30ヶ所以上の変更</p>
                                    <p class="caption font-weight-black" style="color: red !important;">・平面図の東西反転または回転あり</p>
                                    <p class="caption font-weight-black" style="color: red !important;">・ゾーニングの変更あり</p>
                                </div>
                            </v-expand-transition>
                            
                            <v-radio v-show="loggedInUser.is_hrd_requestor != 1" label="通常な変更あり(前回依頼分より)" value="3" :disabled="cadRequestBasicInformation.kakouirai_reason == 1 || cadRequestBasicInformation.kakouirai_reason == 2"></v-radio>
                            <v-expand-transition>
                                <div class="pl-8" v-if="radio == 3">
                                    <!-- <p class="caption font-weight-black" style="color: red !important;"> 約30箇所以内の変更箇所ゾーニングの変更あり </p> -->
                                    <p class="caption font-weight-black" style="color: red !important;">・約30ヶ所以内の変更</p>
                                    <p class="caption font-weight-black" style="color: red !important;">・平面図の東西反転または回転なし</p>
                                    <p class="caption font-weight-black" style="color: red !important;">・ゾーニングの変更なし</p>
                                </div>
                            </v-expand-transition>

                            <v-radio v-show="loggedInUser.is_hrd_requestor != 1" label="小さな変更あり(前回依頼分より)" value="4" :disabled="cadRequestBasicInformation.kakouirai_reason == 1 || cadRequestBasicInformation.kakouirai_reason == 2"></v-radio>
                            <v-expand-transition>
                                <div class="pl-8" v-if="radio == 4">
                                    <!-- <p class="caption font-weight-black" style="color: red !important;"> 約10箇所以下の内部の変更 約５箇所以下の外部の変更 屋根伏せ図の変更 </p> -->
                                    <p class="caption font-weight-black" style="color: red !important;">・約10ヵ所以内の内部変更</p>
                                    <p class="caption font-weight-black" style="color: red !important;">・約５ヵ所以内の外部変更</p>
                                    <p class="caption font-weight-black" style="color: red !important;">・平面図の東西反転または回転なし</p>
                                    <p class="caption font-weight-black" style="color: red !important;">・ゾーニングの変更なし</p>
                                </div>
                            </v-expand-transition>

                            <v-radio v-show="loggedInUser.is_hrd_requestor != 1" :disabled="cadRequestBasicInformation.kakouirai_reason == 1 || cadRequestBasicInformation.kakouirai_reason == 2" label="CAD図面番号の変更なし" value="6"></v-radio>

                            <!-- 旧CAD依頼書からの切り替え -->
                            <v-radio v-show="loggedInUser.is_hrd_requestor != 1" label="旧CAD依頼書からの切り替え" value="5"></v-radio>
                            <!-- <v-radio v-show="loggedInUser.is_hrd_requestor != 1" label="【枠組】構造事前検討依頼のみ（図面の親番号：0）" value="5"></v-radio> -->
                            <v-expand-transition>
                                <div class="pl-8" v-if="radio == 5">
									<!-- <span class="caption font-weight-black">※構造事前検討結果及びiCADデータのみ作成</span> -->
									<span class="caption font-weight-black">図面番号入力:</span>
                                        <span>
                                            <form ref="CustomRevision">
                                                <v-row no-gutters>
                                                    <v-col cols="5">
                                                        <!-- ----------OLD--------- -->
                                                        <!-- <v-text-field
                                                        style="border: none !important;"
                                                        v-model="firstDigit"
                                                        @input="handleInput"
                                                        @keydown="handleKeydown"
                                                        outlined
                                                        class="centered-input"
                                                        dense
                                                        type="text"
                                                        name="firstDigit"
                                                        ></v-text-field>   -->
                                                        <!-- ----------NEW--------- -->
                                                        <v-text-field
                                                            style="border: none !important;"
                                                            v-model="firstDigit"
                                                            oninput="validity.valid||(value='')"
                                                            hide-spin-buttons
                                                            outlined
                                                            class="centered-input"
                                                            dense
                                                            name="firstDigit"
                                                            @compositionstart="imeStarted(1)"
                                                            @compositionend="imeEnded(1)"
                                                        ></v-text-field>  
                                                    </v-col>
                                                    <v-col cols="2" class="text-center">
                                                        <span> <v-icon class="pt-2">mdi-minus</v-icon> </span>
                                                    </v-col>
                                                    <v-col cols="5" style="text-align: center !important">
                                                        <template v-if="this.$store.state.kakou_reason == 1 || this.$store.state.kakou_reason == 2">
                                                            <v-autocomplete
                                                                v-model="secondDigit"
                                                                @input="handleInput"
                                                                @change="checkOldRevisions"
                                                                dense
                                                                outlined
                                                                name="secondDigit"
                                                                :items="reasonNumber"
                                                                item-text="text"
                                                                item-value="value">
                                                            </v-autocomplete>
                                                        </template>
                                                        <!-- ----------OLD--------- -->
                                                        <!-- <v-combobox
                                                            v-else
                                                            v-model="secondDigit"
                                                            @input="handleInput"
                                                            @change="checkOldRevisions"
                                                            outlined
                                                            dense
                                                            label=" "
                                                            :items="dropNumber"
                                                            name="secondDigit">
                                                        </v-combobox>    -->
                                                        <!-- ----------NEW--------- -->
                                                        <template v-else>
                                                            <v-menu
                                                                v-model="menu"
                                                                :close-on-content-click="false"
                                                                transition="scale-transition"
                                                                offset-y
                                                            >
                                                                <template v-slot:activator="{ on }">
                                                                    <v-text-field
                                                                        v-model="secondDigit"
                                                                        v-on="on"
                                                                        outlined dense
                                                                        @compositionstart="imeStarted(2)"
                                                                        @compositionend="imeEnded(2)"
                                                                        @input="checkOldRevisions"
                                                                        :disabled="!firstDigit"
                                                                    ></v-text-field>
                                                                </template>

                                                                <v-list>
                                                                    <v-list-item
                                                                        v-for="item in dropNumber"
                                                                        :key="item"
                                                                        @click="selectSecondDigit(item)"
                                                                    >
                                                                        <v-list-item-title>{{ item }}</v-list-item-title>
                                                                    </v-list-item>
                                                                </v-list>
                                                            </v-menu>
                                                        </template>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <v-radio-group v-model="radio3" dense :disabled="checkRadio3Disabled" name="radio3" @change="checkOldRevisions">
                                                            <v-radio label="新規CAD依頼(図面番号)" value="5Z" :disabled="cadRequestBasicInformation.house_type_id == 4 || cadRequestBasicInformation.house_type_id == 5 || cadRequestBasicInformation.house_type_id == 3 || cadRequestBasicInformation.house_type_id == 29 || cadRequestBasicInformation.house_type_id == 22"></v-radio>
                                                                <v-expand-transition>
                                                                    <div class="pl-8" v-show="radio3 == '5Z'">
                                                                        <form ref="ZPlan">
                                                                            <v-radio-group v-model="radio4" dense>
                                                                                <v-radio label="施工面積58坪未満" value="5ZA" name="more_than_58_tsubo"></v-radio>
                                                                                <v-radio label="施工面積58坪以上" value="5ZB" name="less_than_58_tsubo"></v-radio>
                                                                            </v-radio-group>
                                                                        </form>
                                                                    </div>
                                                                </v-expand-transition>

                                                            <v-radio label="大きな変更あり(前回依頼分より)" value="5A"></v-radio>
                                                                <v-expand-transition>
                                                                    <div class="pl-8" v-show="radio3 == '5A'">
                                                                        <p class="caption font-weight-black" style="color: red !important;">・約30ヶ所以上の変更</p>
                                                                        <p class="caption font-weight-black" style="color: red !important;">・平面図の東西反転または回転あり</p>
                                                                        <p class="caption font-weight-black" style="color: red !important;">・ゾーニングの変更あり</p>
                                                                    </div>
                                                                </v-expand-transition>
                                                                
                                                            <v-radio label="通常な変更あり(前回依頼分より)" value="5B"></v-radio>
                                                                <v-expand-transition>
                                                                    <div class="pl-8" v-show="radio3 == '5B'">
                                                                        <p class="caption font-weight-black" style="color: red !important;">・約30ヶ所以内の変更</p>
                                                                        <p class="caption font-weight-black" style="color: red !important;">・平面図の東西反転または回転なし</p>
                                                                        <p class="caption font-weight-black" style="color: red !important;">・ゾーニングの変更なし</p>
                                                                    </div>
                                                                </v-expand-transition>

                                                            <v-radio label="小さな変更あり(前回依頼分より)" value="5C"></v-radio>
                                                                <v-expand-transition>
                                                                    <div class="pl-8" v-show="radio3 == '5C'">
                                                                        <p class="caption font-weight-black" style="color: red !important;">・約10ヵ所以内の内部変更</p>
                                                                        <p class="caption font-weight-black" style="color: red !important;">・約５ヵ所以内の外部変更</p>
                                                                        <p class="caption font-weight-black" style="color: red !important;">・平面図の東西反転または回転なし</p>
                                                                        <p class="caption font-weight-black" style="color: red !important;">・ゾーニングの変更なし</p>
                                                                    </div>
                                                                </v-expand-transition>

                                                            <v-radio label="CAD図面番号の変更なし" value="5D"></v-radio>

                                                        </v-radio-group>
                                                    </v-col>
                                                </v-row>
                                            </form>  
                                            
                                            <!-- <span class="overline font-weight-black">
                                                -
                                            </span>
                                            <v-otp-input
                                            length="1"
                                            type="number"
                                            ></v-otp-input>  -->
                                        </span>  
                                </div>
                            </v-expand-transition>

                            <h5 v-show="loggedInUser.is_hrd_requestor != 1" style="margin: 10px 0 20px; text-align: center; letter-spacing: 0.2rem; border-bottom: 1px solid orange; line-height: 0.1em; color: red"><span style="background:#fff; padding:0 10px; ">トライアルエリアのみ使用</span></h5>

                            <!-- 【枠組】構造事前検討依頼のみ（図面の親番号：0） -->
                            <!-- <v-radio v-show="loggedInUser.is_hrd_requestor != 1" label="iCAD構造事前検討依頼（図面番号：0-1）" value="7"></v-radio> -->
                            <v-radio v-show="loggedInUser.is_hrd_requestor != 1" :disabled="cadRequestBasicInformation.kakouirai_reason == 1 || cadRequestBasicInformation.kakouirai_reason == 2" label="【枠組】構造事前検討依頼のみ（図面の親番号：0）" value="7"></v-radio>
                            <v-expand-transition>
                                <div class="pl-8" v-if="radio == 7">
                                    <span class="caption" style="color:red;">※トライアルエリア以外での依頼は不可</span><br>
									<span class="caption font-weight-black">※構造事前検討結果及びiCADデータのみ作成</span>
									<span class="caption font-weight-black">図面番号入力:</span>
                                        <span>
                                            <form ref="CustomRevision">
                                                <v-row no-gutters>
                                                    <v-col cols="5">
                                                        <div class="text-right mt-2">
                                                            <span class="caption" style="font-size: 20px !important;">{{fixedFirstDigit}}</span>
                                                        </div>

                                                        <!-- <v-text-field
                                                        v-model="fixedFirstDigit"
                                                        outlined
                                                        readonly
                                                        dense
                                                        type="text"
                                                        name="fixedFirstDigit"
                                                        ></v-text-field>    -->
                                                    </v-col>
                                                    <v-col cols="2" class="text-center">
                                                        <span> <v-icon class="pt-2">mdi-minus</v-icon> </span>
                                                    </v-col>
                                                    <v-col cols="5">
                                                        <v-text-field
                                                        v-model="newSecondDigit"
                                                        @input="handleInput"
                                                        outlined
                                                        dense
                                                        type="text"
                                                        name="secondDigit"
                                                        ></v-text-field>   
                                                    </v-col>
                                                        <!-- :rules="rules.positiveNumber" -->

                                                    <v-col cols="12">
                                                        <v-radio-group v-model="secondRadio3" dense :disabled="checkSecondRadio3Disabled" name="radio3">
                                                            <v-radio :label="`新規CAD依頼`" value="7Cad"></v-radio>
                                                                <v-expand-transition>
                                                                    <div class="pl-8" v-show="secondRadio3 == '7Cad'">
                                                                        <v-radio-group v-model="icad1" dense>
                                                                            <v-radio label="施工面積58坪未満" value="1A" name="more_than_58_tsubo"></v-radio>
                                                                            <v-radio label="施工面積58坪以上" value="1B" name="less_than_58_tsubo"></v-radio>
                                                                        </v-radio-group>
                                                                    </div>
                                                                </v-expand-transition>
                                                            <v-radio label="大きな変更あり(前回依頼分より)" value="7A"></v-radio>
                                                                <v-expand-transition>
                                                                    <div class="pl-8" v-show="secondRadio3 == '7A'">
                                                                        <p class="caption font-weight-black" style="color: red !important;" >・約30ヶ所以上の変更</p>
                                                                        <p class="caption font-weight-black" style="color: red !important;" >・平面図の東西反転または回転あり</p>
                                                                        <p class="caption font-weight-black" style="color: red !important;" >・ゾーニングの変更あり</p>
                                                                    </div>
                                                                </v-expand-transition>
                                                                
                                                                <v-radio label="通常な変更あり(前回依頼分より)" value="7B"></v-radio>
                                                                <v-expand-transition>
                                                                    <div class="pl-8" v-show="secondRadio3 == '7B'">
                                                                        <p class="caption font-weight-black" style="color: red !important;"> ・約30ヶ所以内の変更 </p>
                                                                        <p class="caption font-weight-black" style="color: red !important;"> ・平面図の東西反転または回転なし </p>
                                                                        <p class="caption font-weight-black" style="color: red !important;"> ・ゾーニングの変更なし </p>
                                                                    </div>
                                                                </v-expand-transition>

                                                                <v-radio label="小さな変更あり(前回依頼分より)" value="7C"></v-radio>
                                                                <v-expand-transition>
                                                                    <div class="pl-8" v-show="secondRadio3 == '7C'">
                                                                        <p class="caption font-weight-black" style="color: red !important;"> ・約10ヵ所以内の内部変更 </p>
                                                                        <p class="caption font-weight-black" style="color: red !important;"> ・約５ヵ所以内の外部変更 </p>
                                                                        <p class="caption font-weight-black" style="color: red !important;"> ・平面図の東西反転または回転なし </p>
                                                                        <p class="caption font-weight-black" style="color: red !important;"> ・ゾーニングの変更なし </p>
                                                                    </div>
                                                                </v-expand-transition>
                                                        </v-radio-group>
                                                    </v-col>
                                                </v-row>
                                            </form>  
                                            <!-- <span class="overline font-weight-black">
                                                -
                                            </span>
                                            <v-otp-input
                                            length="1"
                                            type="number"
                                            ></v-otp-input>  -->
                                        </span>  
                                </div>
                            </v-expand-transition>

                            <h5 v-show="loggedInUser.is_admin == 1 || loggedInUser.is_hrd_requestor == 1 || loggedInUser.plan_control == 1" style="margin: 10px 0 20px; text-align: center; letter-spacing: 0.2rem; border-bottom: 1px solid orange; line-height: 0.1em; color: red"><span style="background:#fff; padding:0 10px; ">HRDのみ使用</span></h5>

                            <!-- HRD PROCESS -->
                            <v-radio v-show="loggedInUser.is_admin == 1 || loggedInUser.is_hrd_requestor == 1" :disabled="cadRequestBasicInformation.kakouirai_reason == 1 || cadRequestBasicInformation.kakouirai_reason == 2" label="HRDミスの訂正 (HRD Process)" value="8"></v-radio>
                            <v-expand-transition>
                                <div class="pl-8" v-if="radio == 8">
									<span class="caption font-weight-black">修正する図面番号を選:</span>
                                        <span>
                                            <form ref="HrdProcessRevision">
                                                <v-row no-gutters>
                                                    <v-col cols="5">
                                                        <v-select
                                                            v-model="revision_hrdProcess"
                                                            :items="existingRevisionNumbers"
                                                            outlined
                                                            dense
                                                            hide-details
                                                            type="text"
                                                            name="hrd_process"
                                                        ></v-select>   
                                                    </v-col>

                                                        <!-- :rules="rules.positiveNumber" -->
                                                </v-row>
                                                <v-row>
                                                    <v-col>
                                                        <v-checkbox
                                                            v-show="loggedInUser.is_admin == 1 || loggedInUser.is_hrd_requestor == 1"
                                                            v-model="copyPrev"
                                                            label="CAD図面番号の変更なし"
                                                        ></v-checkbox>
                                                    </v-col>
                                                </v-row>
                                            </form>  
                                            <!-- <span class="overline font-weight-black">
                                                -
                                            </span>
                                            <v-otp-input
                                            length="1"
                                            type="number"
                                            ></v-otp-input>  -->
                                        </span>  
                                </div>
                            </v-expand-transition>

                            <!-- CPN RADIO BUTTON -->
                            <v-radio v-show="loggedInUser.is_admin == 1 || loggedInUser.is_hrd_requestor == 1" label="HRDよりCAD依頼(CPN)" value="9"></v-radio>
                            <v-expand-transition>
                                <div class="pl-8" v-if="radio == 9">
									<span class="caption font-weight-black">修正する図面番号を選:</span>
                                        <span>
                                            <form ref="HrdProcessRevision">
                                                <v-row no-gutters>
                                                    <v-col cols="5">
                                                        <v-select
                                                            v-model="revision_CPN"
                                                            :items="sortedPlanNumbers"
                                                            outlined
                                                            dense
                                                            hide-details
                                                            type="text"
                                                            name="cpn"
                                                        ></v-select>   
                                                    </v-col>

                                                        <!-- :rules="rules.positiveNumber" -->
                                                </v-row>
                                                <v-row>
                                                    <v-col>
                                                        <v-checkbox
                                                            v-show="loggedInUser.is_admin == 1 || loggedInUser.is_hrd_requestor == 1"
                                                            v-model="copyPrevRetain"
                                                            label="CAD図面番号の変更なし"
                                                        ></v-checkbox>
                                                    </v-col>
                                                </v-row>
                                            </form>  
                                            <!-- <span class="overline font-weight-black">
                                                -
                                            </span>
                                            <v-otp-input
                                            length="1"
                                            type="number"
                                            ></v-otp-input>  -->
                                        </span>  
                                </div>
                            </v-expand-transition>

                            <!-- APPLY IN THE NEXT CAD REQUEST -->
                            <v-radio v-show="loggedInUser.is_admin == 1 || loggedInUser.is_hrd_requestor == 1 || loggedInUser.plan_control == 1" label="Apply in the next CAD Request" value="10"></v-radio>
                            <v-expand-transition>
                                <div class="pl-8" v-if="radio == 10">
                                    <span class="caption red--text">Mistake from revision number:</span>
                                        <span>
                                            <v-col cols="5">
                                                <v-select
                                                    v-model="applyNextCad"
                                                    :items="sortedPlanNumbers"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="text"
                                                    name="next"
                                                    :loading="isLoading"
                                                    :disabled="isLoading">
                                                </v-select>
                                            </v-col>
                                        </span>
                                </div>
                            </v-expand-transition>

                        </v-radio-group>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-checkbox v-if="showCheck" :disabled="setAsDefault" v-model="noBossCheckbox" class="mr-2 mt-3" label="BOSS W/O"></v-checkbox>
                        <v-btn dark color="success" small  @click="sendDialogRevisionData" :disabled="checkRadioDisabled"> 保存 </v-btn>
                    </v-card-actions>
                </v-container>
            </v-card>
        </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Swal from 'sweetalert2';
export default {
    props: {
        dialog : Boolean
    },

    data() {
        return {
            envDB: process.env.MIX_DB_DATABASE,
            env: {
				response : process.env.MIX_ENV == 'local' ? 'response-local' : 'response',
				request : process.env.MIX_ENV == 'local' ? 'request-local' : 'request',
			},
            isLoading: false,
            setAsDefault: false,
            noBossCheckbox: false,
            showCheck: false,
            getRevisionNumber : [],
            copyPrev : false,
            copyPrevRetain : false,
            fixedFirstDigit: 0,
            newSecondDigit: null,
            autosecondDigit: null,
            radio: null,
            radio2: null,
            radio3: null,
            radio4: null,
            secondRadio3: '5C',
            icad1: null,
            revisionDetails: null,
            revision: '',
            firstDigit: null,
            secondDigit: null,
            currentRevision: '1-0',
            existingRevisionNumbers : [],
            revision_hrdProcess : null,
            revision_CPN : null,
            applyNextCad : null,
            getPlanCode : null,
            newShio : null,
            planNumbers : [],
            // getValRadio : null,
            reasonNumber: [
                {text : "1", value : "1"},
                {text : "2", value : "2"},
                {text : "3", value : "3"},
                {text : "4", value : "4"},
                {text : "5", value : "5"},
            ],

            dropNumber : [
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
            ],

            menu: false,

            oldRevisions : []
        }
    },

    computed: {
        ...mapState([
            'loggedInUser',
            'rules',
            'existingRevisions',
            'cadRequestRevisionContent',
            'editCadRequestRevisionContent',
            'disableSelections',
            'structural_request',
            'cadRequestColorPers',
            'hideColorPersTable',
            'hrd_process_stamp',
            'hrdprocessMode',
            'editFinalPlan',
            'editMode',
            'kakou_reason',
            'bossCode',
            'cadRequestBasicInformation',
            'revisionSelection',
            'gravityBoss',
            'getHouseId'
        ]),

        checkRadio3Disabled(){
            return !this.firstDigit || !this.secondDigit
        },

        checkSecondRadio3Disabled(){
            return !this.newSecondDigit
        },

        checkRadioDisabled(){
            if(!this.radio) return true
            
            if(this.radio == 1 && this.radio2){
                return false
            }else if(this.radio == 5 && (this.firstDigit && this.secondDigit) && this.radio3){
                return false
            }else if(this.radio == 7 && this.newSecondDigit){
                return false
            }else if(this.radio == 8 && (this.revision_hrdProcess || this.copyPrev)) {
                return false
            }else if(this.radio == 9 && (this.revision_CPN || this.copyPrevRetain)){
                return false
            }else if(this.radio == 10 && this.applyNextCad) {
                return false
            }else if(this.radio != 5 && this.radio != 1 && this.radio != 8 && this.radio != 9 && this.radio != 7 && this.radio != 10){
                return false
            }else{
                return true
            }
        },

        //NOTE - ORIGINAL CODE - COMMENTED BY UARY DEC222025
        // possibleRevision(){
        //     const revisionContent = this.currentRevision.split('-');
        //     const existingRevisions = this.$store.state.existingRevisions;
        //     // Find the latest revision where revision_type is not equal to '7' or SI selection
        //     let getLatestIndex = -1;
        //     for (let i = existingRevisions.length - 1; i >= 0; i--) {
        //         if (existingRevisions[i].revision_type !== '7' && existingRevisions[i].revision_type !== '8') {
        //             getLatestIndex = i;
        //             // console.log(getLatestIndex,'Latest Index')
        //             break;
        //         }
        //     }
    
        //     if (getLatestIndex !== -1) {
        //         const latestRevision = existingRevisions[getLatestIndex];
        //         const latestRevisionNumber = latestRevision.revision_number;
        //         const revisionContentx = latestRevisionNumber.split('-');
        //         const revisionContentLetter = this.currentRevision.split('-');
        //         // console.log(latestRevision , 'latestRevision')
        //         // console.log(latestRevisionNumber , 'latestRevisionNumber')
        //         // console.log(revisionContentx , 'revisionContentx')
        //         // console.log(revisionContentLetter , 'revisionContentLetter')
                
        //         if(isNaN(revisionContentx[1])) { // PAG MAY LETTER SA REVISION (EX. 4-0A => 4-1)
        //             return `${revisionContentLetter[0]}-${+revisionContentLetter[1] + 1}`
        //         } else { // PAG WALANG LETTER MAG ADD SYA SA UNAHAN (EX. 2-1 => 3-1)
        //             const incrementedFirstPart = parseInt(revisionContentx[0]) + 1;
        //             return `${incrementedFirstPart}-${revisionContentx[1]}`;
        //             // return `${revisionContent[0]}-${+revisionContent[1]+1}`
        //         }
        //     } else {
        //         const revisionContent = this.currentRevision.split('-');
        //         if(/[a-zA-Z]/g.test(revisionContent[0])){
        //             revisionContent[0] = 0;
        //             return `${parseInt(revisionContent[0]) + 1}-0`;
        //         } else {
        //             return `${parseInt(revisionContent[0]) + 1}-0`;
        //         }
        //     }
        //     // if(/[a-zA-Z]/g.test(revisionContent[0])) {
        //     //     revisionContent[0] = '0';
        //     // }
        //     // console.log(`${parseInt(revisionContent[0]) + 1}-0`, 'revisions')

        //     // OLD RULE FOR REVISION
        //     // const revisionContent = this.currentRevision.split('-');
        //     // if(/[a-zA-Z]/g.test(revisionContent[0])){
        //     //     revisionContent[0] = 0;
        //     //     return `${parseInt(revisionContent[0]) + 1}-0`;
        //     // } else {
        //     //     return `${parseInt(revisionContent[0]) + 1}-0`;
        //     // }
        //     // console.log(revisionContent,'revisionContent')
        //     // console.log(`${revisionContent[0] + 1}-0`, '${parseInt(revisionContent[0])`')
        //     // return `${revisionContent[0] + 1}-0`
        // }, 

        // NOTE - MODIFIED BY UARY DEC222025
        possibleRevision() {
            const existingRevisions = this.$store.state.existingRevisions;
            
            // 1. Find the latest valid revision index (excluding types 7 and 8)
            let getLatestIndex = -1;
            for (let i = existingRevisions.length - 1; i >= 0; i--) {
                if (existingRevisions[i].revision_type !== '7' && existingRevisions[i].revision_type !== '8') {
                    getLatestIndex = i;
                    break;
                }
            }

            if (getLatestIndex !== -1) {
                const latestRevisionNumber = existingRevisions[getLatestIndex].revision_number;
                const revisionParts = latestRevisionNumber.split('-'); // e.g., ["4", "0A"]
                const currentParts = this.currentRevision.split('-');  // e.g., ["S", "1"]

                // Logic for existing revisions
                if (isNaN(revisionParts[1])) { 
                    // Case: Letter in second part (e.g., 4-0A => 4-1)
                    // Ensure first part is treated as number even if it's "S"
                    const firstPart = isNaN(currentParts[0]) ? 0 : parseInt(currentParts[0]);
                    return `${firstPart}-${parseInt(currentParts[1]) + 1}`;
                } else { 
                    // Case: No letter (e.g., 2-1 => 3-1)
                    const incrementedFirstPart = (parseInt(revisionParts[0]) || 0) + 1;
                    return `${incrementedFirstPart}-${revisionParts[1]}`;
                }
            } else {
                // 2. Default logic if no history exists (Handles "S-1")
                const revisionContent = this.currentRevision.split('-');
                let firstPart = revisionContent[0];

                // Check if first part is a letter (like "S")
                if (/[a-zA-Z]/.test(firstPart)) {
                    firstPart = 0; 
                }

                return `${parseInt(firstPart) + 1}-0`;
            }
        },

        addOneInSecondDigit(){
            // console.log(this.currentRevision, "this.currentRevision")
            // const revisionContent = this.currentRevision.split('-');
            // return `${revisionContent[0]}-${+revisionContent[1] + 1}`

            // BAGONG NEW RULE
            const existingRevisions = this.$store.state.existingRevisions;
            // Find the latest revision where revision_type is not equal to '7' or SI selection
            let getLatestIndex = -1;
            for (let i = existingRevisions.length - 1; i >= 0; i--) {
                if (existingRevisions[i].revision_type !== '7') {
                    getLatestIndex = i;
                    // console.log(getLatestIndex,'Latest Index')
                    break;
                }
            }

            if (getLatestIndex !== -1) {
                const latestRevision = existingRevisions[getLatestIndex];
                const latestRevisionNumber = latestRevision.revision_number;
                const revisionContent = latestRevisionNumber.split('-');
                const revisionContentLetter = this.currentRevision.split('-');
                if(isNaN(revisionContent[1])) { // PAG MAY LETTER SA REVISION (EX. 4-0A => 4-1)
                    return `${revisionContentLetter[0]}-${+revisionContentLetter[1] + 1}`
                } else { // PAG WALANG LETTER MAG ADD LANG SYA
                    return `${revisionContent[0]}-${+revisionContent[1]+1}`
                }
                // console.log('Latest valid revision number:', latestRevisionNumber);
            } else {
                console.log('No valid revisions found');
            }
        },

        sortedPlanNumbers() {
            this.isLoading = true
            // Sort the plan numbers based on the custom logic
            return this.planNumbers.sort((a, b) => {
                const [aFirst, aSecond] = a.split('-').map(Number);
                const [bFirst, bSecond] = b.split('-').map(Number);
                
                // First compare the part before the hyphen
                if (aFirst !== bFirst) {
                return bFirst - aFirst; // Sort in descending order
                }
                this.isLoading = false;
                // If the first parts are equal, compare the part after the hyphen
                return bSecond - aSecond; // Sort in descending order
            })
        }

    },

    sockets : {
        updateReceived: async function(socket) {
            if(socket && socket.dispatchType == this.env.response && socket.functionType == 'nextCadRequest' && socket.uniqId == this.loggedInUser.uniqId && this.$route.path == '/cadrequest') {
                this.getPlanCode = socket.data.nextCadData
                if(this.getPlanCode) {
                    this.planNumbers = socket.data.nextCadData.map(item => item.plan_number)
                }
                // console.log(socket.data.nextCadData,'socketdata')
            }else if(socket && socket.dispatchType == this.env.response && socket.functionType == 'newRefSite' && socket.uniqId == this.loggedInUser.uniqId && this.$route.path == '/cadrequest') {
                this.$store.state.newSite = socket.data.siteRef
                // console.log(this.$store.state.newSite,'siteeeeeees')
            }else if(socket && socket.dispatchType == this.env.response && socket.functionType == 'newRefShio' && socket.uniqId == this.loggedInUser.uniqId && this.$route.path == '/cadrequest') {
                this.$store.state.newShio = socket.data.shioRef
                // console.log(this.$store.state.newShio,'shiooooooo')
            }else if(socket && socket.dispatchType == this.env.response && socket.functionType == 'check_old_revisions' && socket.uniqId == this.loggedInUser.uniqId && this.$route.path == '/cadrequest') {
                // console.log(socket.data.revisionData.length, 'check_old_revisions')
                this.oldRevisions = socket.data.revisionData
            }
            // ----- SSD24-1227783-1916 - JIBAN -----
            else if(socket && socket.dispatchType == this.env.response && socket.functionType == 'jibanDataRes' && socket.uniqId == this.loggedInUser.uniqId && this.$route.path == '/cadrequest'){
                this.$store.state.jibanData = socket.data.jibanData
            }
            // ----- FOR 3RD TIME AND MORE ALVS REQUEST -----
            else if(socket && socket.dispatchType == this.env.response && socket.functionType == 'countAlvsStopCheck' && socket.uniqId == this.loggedInUser.uniqId && this.$route.path == '/cadrequest'){
                this.$store.state.countOfAlvsRequest = socket.data.alvsRequestCount
            }
        }
    },

    methods: {
        // LENGTH OF FP IN XML BUNDLE SCHED V2
        // checkXmlTableLength(){
        //     if (this.$store.state.xmlTable.length === 0) {
        //         Swal.fire({
        //             html: '<div style="text-align: center;font-size:19px;font-weight:bold;">' +
        //                 '初回 着手準備依頼はCAD変更に影響する可能性があります。<br>' +
        //                 `図面番号入力で<span style="color:blue;">「CAD図面番号の変更なし」</span>を選択しないでください。<br>`,
        //             icon: 'warning',
        //             width : 670,
        //         }).then((resulta) => {
        //             if(resulta.isConfirmed) {
        //                 this.radio = null;
        //                 this.radio3 = null;
        //                 return false;
        //             }
        //         })
        //     }
        // },

        // PAG MAY SPECIAL CHARACTER NA ILALAGAY SI PLANNER HINDI ITO MA-TYTYPE , @KEYDOWN ETO YUNG BAWAT TYPE
        // EVENT HANDLER AY KEYBOARD EVENT SYA NA BAWAT INPUT OR TYPE AY NAPAPASA
        // YUNG PREVENT DEFAULT, PINIPIGILAN KASI NITO YUNG MGA HINDI PWEDENG ILAGAY TULAD NG SPECIAL CHARACTERS
        handleKeydown(event) {
            const key = event.key || String.fromCharCode(event.which || event.keyCode);
            if (!key.match(/[\d]/)) {
                event.preventDefault(); 
                this.firstDigit = this.firstDigit.toString().replace(/[^0-9]/g, '');
            }
        },

        handleInput: function() {
            if (this.firstDigit) {
                this.firstDigit = this.convertJapaneseNumber(this.firstDigit.toString());
            }
            if (this.newSecondDigit) {
                this.newSecondDigit = this.convertJapaneseNumber(this.newSecondDigit.toString());
            }
            
            if(this.secondDigit){
                this.secondDigit = this.convertJapaneseNumber(this.secondDigit.toString());
            }
        },

        imeStarted(digitType) {
            if (digitType == 1) {
                this.firstDigit = null
            } else if (digitType == 2) {
                this.secondDigit = null
            }
            this.isIMEActive = true
            alert('「半角英数字のみ入力可能です。入力モードを英語（半角）に切り替えてください。」')
        },

        imeEnded(digitType) {
            this.isIMEActive = false
            if (digitType == 1) {
                this.firstDigit = null
            } else if (digitType == 2) {
                this.secondDigit = null
            }
        },

        selectSecondDigit(item) {
            this.secondDigit = item
            this.menu = false
            if (this.secondDigit ) this.checkOldRevisions()
        },

        handleKeyUp() {
            this.$refs.secondRef.updateSelf()
        },

        // NOTE : XML BUNDLE TABLE V2 DATA FOR FINAL PLAN
        async xmlBundleTable(data){
            try {
                await this.$socket.emit('newUpdate', {
                    dispatchType: this.env.request,
                    data: {
                        uniqId: this.loggedInUser.uniqId,
                        xmlBundleData : data
                    },
                    functionType: 'xml_bundle_table'
                });
            } catch (error) {
                console.log(error, 'socket error')
            }
        },

        // FOR CHECKING OF OLD REVISION
        async checkOldRevisions() {
            // console.log(this.firstDigit + '-' + this.secondDigit)
            // console.log(this.cadRequestBasicInformation.construction_code)
            try {
                await this.$socket.emit('newUpdate', {
                    dispatchType: this.env.request,
                    data: {
                        uniqId: this.loggedInUser.uniqId,
                        customer_code : this.cadRequestBasicInformation.construction_code,
                        revision_number : this.firstDigit + '-' + this.secondDigit
                    },
                    functionType: 'checkOldRevisions'
                });
            } catch (error) {
                console.log(error, 'socket error')
            }
        },


        // NOTE: FOR APPLY IN THE NEXT CAD REQUEST DATA
        async forNextCadRequest(data){
            try {
                await this.$socket.emit('newUpdate', {
                    dispatchType: this.env.request,
                    data: {
                        uniqId: this.loggedInUser.uniqId,
                        nextCadData : data
                    },
                    functionType: 'apply_next_cad'
                });
            } catch (error) {
                console.log(error, 'socket error')
            }
        },

        // NOTE : NEW REFERENCE FOR SITE.... HAYS..
        async referenceSite(data){
            try {
                await this.$socket.emit('newUpdate', {
                    dispatchType: this.env.request,
                    data : {
                        uniqId : this.loggedInUser.uniqId,
                        referenceSite : data
                    },
                    functionType : 'new_reference_site'
                });
            } catch (error) {
                console.log(error, 'socket error!')
            }
        },

        // NOTE : NEW REFERENCE FOR SHIO
        async referenceShio(data){
            try {
                await this.$socket.emit('newUpdate', {
                    dispatchType: this.env.request,
                    data : {
                        uniqId : this.loggedInUser.uniqId,
                        referenceShio : data
                    },
                    functionType : 'new_reference_shio'
                });
            } catch (error) {
                console.log(error, 'socket error!')
            }
        },

        // ----- FOR 3RD TIME AND MORE ALVS REQUEST -----
        async getALVSStopCheck(data){
            await this.$socket.emit("newUpdate", {
                dispatchType: this.env.request,
                data: {
                    uniqId: this.loggedInUser.uniqId,
                    customer_code : data
                },
                functionType: "alvs_stop_check",
            });
        },

        // ----- SSD24-1227783-1916 - JIBAN -----
        async getJibanData(data){
            await this.$socket.emit("newUpdate", {
                dispatchType: this.env.request,
                data: {
                    uniqId: this.loggedInUser.uniqId,
                    customer_code : data
                },
                functionType: "jibanDataRec",
            });
        },

        convertJapaneseNumber: function(text) {
            // console.log(text, 'text')
            if(text){
                text = text.replace(/\s+/g, ''); // Auto remove of spacing if meron
                const fullWidthNumbers = ['０', '１', '２', '３', '４', '５', '６', '７', '８', '９'];
                const arabicNumerals = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

                for (let i = 0; i < fullWidthNumbers.length; i++) {
                    text = text.replace(new RegExp(fullWidthNumbers[i], 'g'), arabicNumerals[i]);
                }
                return text;
            }
        },

        planGravity(){
            // if(this.loggedInUser.is_hrd_requestor == 1){
            //     this.radio = '8';
            // }
            // console.log(this.radio, 'radio')

            if(!this.$store.state.editMode){
                
                this.cadRequestRevisionContent.revision_type = this.radio;
                // GRAVITY :
                //     small = 1
                //     medium = 2
                //     large = 3
                if(this.radio == '1'){
                    this.$store.state.disableApplyNextCad = false;
                    if(this.radio2 == '1A'){
                        this.cadRequestRevisionContent.gravity = 2
                    }else if(this.radio2 == '1B'){
                        this.cadRequestRevisionContent.gravity = 3
                    }
                }else if(this.radio == '2'){
                    this.$store.state.disableApplyNextCad = false;
                    this.cadRequestRevisionContent.gravity = 3
                }else if(this.radio == '3'){
                    this.$store.state.disableApplyNextCad = false;
                    this.cadRequestRevisionContent.gravity = 2
                }else if(this.radio == '4'){
                    this.$store.state.disableApplyNextCad = false;
                    this.cadRequestRevisionContent.gravity = 1
                }else if(this.radio == '5'){
                    this.$store.state.disableApplyNextCad = false;
                    this.cadRequestRevisionContent.gravity_type = this.radio3
                    if(this.radio3 == '5Z'){
                    if(this.radio4 == '5ZA'){
                        this.cadRequestRevisionContent.gravity = 2
                    }else if(this.radio4 == '5ZB'){
                        this.cadRequestRevisionContent.gravity = 3
                    }
                    }
                    if(this.radio3 == '5A'){
                        this.cadRequestRevisionContent.gravity = 3
                    }else if(this.radio3 == '5B'){
                        this.cadRequestRevisionContent.gravity = 2
                    }else if(this.radio3 == '5C'){
                        this.cadRequestRevisionContent.gravity = 1
                    } else if(this.radio3 == '5D'){
                        // this.cadRequestRevisionContent.gravity = 4
                        this.cadRequestRevisionContent.gravity = 0
                    }
                    var regExp = /[a-zA-Z]/g;
                    if(regExp.test(this.secondDigit)){
                    /* do something if letters are found in your string */
                        let letter = this.secondDigit.slice(-1).toUpperCase();
                        this.secondDigit = this.secondDigit.slice(0, -1)
                        this.secondDigit = this.secondDigit+letter;
                    }
                }else if(this.radio == '6'){
                    this.$store.state.disableApplyNextCad = false;
                    this.cadRequestRevisionContent.gravity = 0
                }
                else if(this.radio == '7'){
                    this.$store.state.disableApplyNextCad = false;
                    this.cadRequestRevisionContent.gravity_type = this.secondRadio3
                    if(this.secondRadio3 == '7A'){
                        this.cadRequestRevisionContent.gravity = 3
                    }else if(this.secondRadio3 == '7B'){
                        this.cadRequestRevisionContent.gravity = 2
                    }else if(this.secondRadio3 == '7C'){
                        this.cadRequestRevisionContent.gravity = 1
                    }else if(this.secondRadio3 == '7Cad'){
                        if(this.icad1 == '1A'){
                            this.cadRequestRevisionContent.gravity = 2
                        }else if(this.icad1 == '1B'){
                            this.cadRequestRevisionContent.gravity = 3
                        }
                    }

                    var regExp = /[a-zA-Z]/g;
                    if(regExp.test(this.newSecondDigit)){
                        let letter = this.newSecondDigit.slice(-1).toUpperCase();
                        this.newSecondDigit = this.newSecondDigit.slice(0, -1)
                        this.newSecondDigit = this.newSecondDigit+letter;
                    }

                    this.$store.state.cadRequestRevisionContent.structural_request = {
                        OPTION_1 : 'あり',
                        OPTION_ZEH : false,
                        OPTION_GX : false,
                        OPTION_2 : 'あり',
                        OPTION_W : 'W2',
                        OPTION_S : null,
                    };
                    this.$store.state.disableSelections = true;
                    return;
                // HRD PROCESS
                }else if(this.radio === '8'){
                    this.$store.state.disableApplyNextCad = false;
                    // this.$store.state.cadRequestRevisionContent.gravity = 1
                    if(this.copyPrev === true){
                        this.$store.state.cadRequestRevisionContent.isHrdCpn = 1;
                        this.$store.state.cadRequestRevisionContent.gravity = 0
                    } else {
                        this.$store.state.cadRequestRevisionContent.gravity = 1
                    }
                }else if(this.radio === '9'){
                    this.$store.state.disableApplyNextCad = false;
                    // this.$store.state.cadRequestRevisionContent.gravity = 1
                    // this.cadRequestRevisionContent.gravity_type = null
                    if(this.copyPrevRetain === true){
                        this.$store.state.cadRequestRevisionContent.isHrdCpn = 1;
                        this.$store.state.cadRequestRevisionContent.gravity = 0
                    } else {
                        this.$store.state.cadRequestRevisionContent.gravity = 1
                        this.cadRequestRevisionContent.gravity_type = null
                    }
                }else if(this.radio === '10') {
                    this.$store.state.disableApplyNextCad = true;
                    this.$store.state.cadRequestRevisionContent.gravity = 4
                    // console.log(this.$store.state.disableApplyNextCad,'disableApplyNextCad')
                }
                    this.$store.state.disableSelections = false;
                    

            }else{
                
                this.editCadRequestRevisionContent.revision_type = this.radio;
                // GRAVITY :
                //     small = 1
                //     medium = 2
                //     large = 3
                if(this.radio == '1'){
                    if(this.radio2 == '1A'){
                        this.editCadRequestRevisionContent.gravity = 2
                    }else if(this.radio2 == '1B'){
                        this.editCadRequestRevisionContent.gravity = 3
                    }
                }else if(this.radio == '2'){
                    this.editCadRequestRevisionContent.gravity = 3
                }else if(this.radio == '3'){
                    this.editCadRequestRevisionContent.gravity = 2
                }else if(this.radio == '4'){
                    this.editCadRequestRevisionContent.gravity = 1
                }else if(this.radio == '5'){
                    this.editCadRequestRevisionContent.gravity_type = this.radio3
                    if(this.radio3 == '5Z'){
                        if(this.radio4 == '5ZA'){
                            this.editCadRequestRevisionContent.gravity = 2
                        }else if(this.radio4 == '5ZB'){
                            this.editCadRequestRevisionContent.gravity = 3
                        }
                    }
                    if(this.radio3 == '5A'){
                        this.editCadRequestRevisionContent.gravity = 3
                    }else if(this.radio3 == '5B'){
                        this.editCadRequestRevisionContent.gravity = 2
                    }else if(this.radio3 == '5C'){
                        this.editCadRequestRevisionContent.gravity = 1
                    } else if(this.radio3 == '5D'){
                        this.editCadRequestRevisionContent.gravity = 0
                    }
                    var regExp = /[a-zA-Z]/g;
                    if(regExp.test(this.secondDigit)){
                    /* do something if letters are found in your string */
                        let letter = this.secondDigit.slice(-1).toUpperCase();
                        this.secondDigit = this.secondDigit.slice(0, -1)
                        this.secondDigit = this.secondDigit+letter;
                    }
                }else if(this.radio == '6'){
                    this.editCadRequestRevisionContent.gravity = 0
                }
                // CADの変更なし
                else if(this.radio == '7'){
                    this.editCadRequestRevisionContent.gravity_type = this.secondRadio3
                    if(this.secondRadio3 == '7A'){
                        this.editCadRequestRevisionContent.gravity = 3
                    }else if(this.secondRadio3 == '7B'){
                        this.editCadRequestRevisionContent.gravity = 2
                    }else if(this.secondRadio3 == '7C'){
                        this.editCadRequestRevisionContent.gravity = 1
                    }else if(this.secondRadio3 == '7Cad'){
                        if(this.icad1 == '1A'){
                            this.editCadRequestRevisionContent.gravity = 2
                        }else if(this.icad1 == '1B'){
                            this.editCadRequestRevisionContent.gravity = 3
                        }
                    }

                    var regExp = /[a-zA-Z]/g;
                    if(regExp.test(this.newSecondDigit)){
                        let letter = this.newSecondDigit.slice(-1).toUpperCase();
                        this.newSecondDigit = this.newSecondDigit.slice(0, -1)
                        this.newSecondDigit = this.newSecondDigit+letter;
                    }

                    this.$store.state.editCadRequestRevisionContent.structural_request = {
                        OPTION_1 : 'あり',
                        OPTION_ZEH : false,
                        OPTION_GX : false,
                        OPTION_2 : 'あり',
                        OPTION_W : 'W2',
                        OPTION_S : null,
                    };
                    this.$store.state.disableSelections = true;
                    return;

                }else if(this.radio === '8'){
                    // this.$store.state.editCadRequestRevisionContent.gravity = 1
                    if(this.copyPrev === true){
                        this.$store.state.editCadRequestRevisionContent.isHrdCpn = 1;
                        this.$store.state.editCadRequestRevisionContent.gravity = 0
                    } else {
                        this.$store.state.editCadRequestRevisionContent.gravity = 1
                    }
                }else if(this.radio === '9'){
                    // this.$store.state.editCadRequestRevisionContent.gravity = 1
                    // this.editCadRequestRevisionContent.gravity_type = null
                    if(this.copyPrevRetain === true){
                        this.$store.state.editCadRequestRevisionContent.isHrdCpn = 1;
                        this.$store.state.editCadRequestRevisionContent.gravity = 0
                    } else {
                        this.$store.state.editCadRequestRevisionContent.gravity = 1
                        this.editCadRequestRevisionContent.gravity_type = null
                    }
                } else if(this.radio === '10') {
                    this.$store.state.disableApplyNextCad = true;
                    this.$store.state.editCadRequestRevisionContent.gravity = 4
                    // console.log(this.$store.state.disableApplyNextCad,'disableApplyNextCad')

                }
                    this.$store.state.disableSelections = false;
            }
            // console.log(this.cadRequestRevisionContent.gravity, "revision")
        },
        toggleDialogRevision(value){
            this.$emit('toggleDialogRevision', value);
            // console.log(value,'value')
        },

        sendDialogRevisionData(){
            // if(this.loggedInUser.is_hrd_requestor == 1){
            //     this.radio = '8';
            // }


            console.log(this.radio, 'radio')
            this.$store.state.getRadio = this.radio;
            // console.log(this.$store.state.getRadio, 'getRadio')
            this.$store.state.hrd_process_stamp = false;
            this.$store.state.cadRequestRevisionContent.hrd_process = 0;
            this.$store.state.isBossChecked = this.noBossCheckbox;
            this.$store.state.isHrdCpn = this.radio == '8' ? this.copyPrev : this.radio == '9' ? this.copyPrevRetain : 0;
            this.$store.state.getCadNashi = this.radio == '6' ? '6' : (this.radio == '5' && this.radio3 == '5D') ? '5' : (this.radio == '8' && this.copyPrev == true) ? '8' : (this.radio == '9' && this.copyPrevRetain == true) ? '9' : null;
            if(this.$store.state.editMode) this.$store.state.editCadRequestRevisionContent.isBossChecked = this.$store.state.isBossChecked;
            this.$store.state.cadRequestRevisionContent.isBossChecked = this.$store.state.isBossChecked;
            this.$store.state.revisionSelection = this.radio;
            this.$store.state.subRevision = this.radio3;
            // console.log(this.$store.state.subRevision,'subRevision')
            // console.log(this.$store.state.isHrdCpn,'hrdcpn')
            this.planGravity();
            // console.log(this.$store.state.cadRequestRevisionContent.isHrdCpn,'isHrdCpn')
            if(this.envDB == 'hrd_cad_request'){
                    let index = this.existingRevisions.length-1;
                switch (this.radio) {
                    case '1':
                            this.revision = this.possibleRevision;
                            // console.log(this.revision, 'rev')
                            this.setStandardFormat();
                        break;
                    case '2':
                        this.revision = this.addOneInSecondDigit;
                        this.setStandardFormat();
                        break;
                    case '3':
                        this.revision = this.addOneInSecondDigit;
                        this.setStandardFormat();
                        break;
                    case '4':
                        this.revision = this.addOneInSecondDigit;
                        this.setStandardFormat();
                        break;
                    case '5':
                            this.revision = `${this.firstDigit}-${this.secondDigit}`;
                            this.setStandardFormat();
                            this.$store.state.cadRequestRevisionContent.hrd_process = 0
                        break;
                    case '6':
                        this.revision = this.existingRevisions[index].revision_number;
                        this.setStandardFormat();
                        break;
                    case '7':
                        this.revision = `${this.fixedFirstDigit}-${this.newSecondDigit}`;
                        break;
                    case '8':
                        this.$store.state.hrdprocessMode = true;
                        this.$store.state.cadRequestRevisionContent.hrd_process = 1;

                        if(this.copyPrev){
                            this.$store.state.cadRequestRevisionContent = {
                                    revision: null,
                                    design_contract: false,
                                    calculation_basis: false,
                                    isBossChecked: null,
                                    site_layout: null,
                                    boss_sending: null,
                                    denki_gravity: null,
                                    gravity_type: this.cadRequestRevisionContent.gravity_type,
                                    gravity: this.cadRequestRevisionContent.gravity,
                                    isHrdCpn : this.cadRequestRevisionContent.isHrdCpn,
                                    site_layout_option: null,
                                    site_diagram : null,
                                    new_site_diagram : null,
                                    specs_irai: { 
                                        sash_type: null,  
                                        specs: null,  
                                        accessories: [], 
                                        honeycomb: null, 
                                        },
                                    dxf_data_request: null,
                                    color_pers: null,
                                    house_presentation: null,
                                    house_presentation_int : null,
                                    shio_request: null,
                                    SRS_request: {
                                        shio_selection: null,
                                        shio_number: null,
                                    },
                                    web_documents: null,
                                    jiban_plan: null,
                                    alvs: null,
                                    status: null,
                                    hrd_process: null,
                                    structural_request: null,
                                    pdr: null,
                                    electrical_drawing: null,
                                    cross_section: null,
                                    elevation_section: null,
                                    stop: null,
                                    stopListSelection: null,
                                    final_plan: null,
                                    express: null,
                                    request_attach_from: null,
                                }
                            this.revision = this.revision_hrdProcess;
                            this.$store.state.cadRequestRevisionContent.design_contract = 1
                            // this.$store.state.cadRequestRevisionContent.shio_request = 1;
                            // this.$store.state.cadRequestRevisionContent.site_layout = '前回ベースP';
                            this.$store.state.cadRequestRevisionContent.hrd_process = 1;
                            this.$store.state.cadRequestRevisionContent.express = 1;

                            // this.$store.state.cadRequestRevisionContent.site_layout = '前回ベースP';
                                if(this.$store.state.cadRequestRevisionContent.site_layout == '前回ベースP'){
                                    this.$store.state.cadRequestRevisionContent.new_site_diagram = 'なし'
                                }
                            // this.$store.state.cadRequestRevisionContent.site_layout = null;

                            this.$store.state.existingRevisions.filter((r) => {
                                if(r.revision_number == this.revision_hrdProcess){
                                    if(r.final_plan == "2" || r.final_plan == "3" || r.final_plan == "1"){
                                        this.$store.state.cadRequestRevisionContent.final_plan = "1";
                                    }
                                }
                            })

                            // console.log(this.$store.state.cadRequestRevisionContent, "content")
                        }else{
                            let splitRev = this.revision_hrdProcess.split('-')

                            if(/[a-zA-Z]/.test(splitRev[0])){
                                this.revision = `${splitRev[0]}-${+splitRev[1]+1}`;
                            }else{
                                this.revision = this.replaceLetterWithNext(this.revision_hrdProcess);
                            }
                            this.$store.state.existingRevisions.filter((r) => {
                                let dra = []
                                if(r.ED_ELECTRICAL_REQUEST){ 
                                    dra = r.ED_ELECTRICAL_REQUEST.split(', ');
                                }

                                if(r.revision_number == this.revision_hrdProcess){
                                    if(r.ED_PDR_TITLE == '提案電気図面依頼' || (r.ED_DENKI_PLAN_TITLE == '電気図面依頼' && r.ED_OPTION_1 == 'あり')) {
                                        this.$store.state.electrical_request = {
                                                                                pdr_title : null,
                                                                                radioPdr : null,
                                                                                denki_plan_title : '電気図面依頼',
                                                                                OPTION_1 : 'あり',
                                                                                OPTION_2 : 'あり',
                                                                                radioGravity : '軽微な変更 (S)',
                                                                                selectedDrawing : [],
                                                                            };
                                        this.$store.state.cadRequestRevisionContent.electrical_drawing = this.$store.state.electrical_request;
                                    } else {
                                        this.$store.state.electrical_request = {
                                                                                pdr_title : null,
                                                                                radioPdr : null,
                                                                                denki_plan_title : null,
                                                                                OPTION_1 : null,
                                                                                OPTION_2 : null,
                                                                                radioGravity : null,
                                                                                selectedDrawing : [],
                                                                            };
                                        this.$store.state.cadRequestRevisionContent.electrical_drawing = this.$store.state.electrical_request;
                                    }
                                }

                            })
                            this.copySelectedRevision()
                        }
                        this.$store.state.cadRequestRevisionContent.revision_type = "8";
                        this.$store.state.hrd_process_stamp = true;
                        break;
                    case '9':
                        let content = this.$store.state.existingRevisions.filter((r) => {
                            if(r.revision_number == this.revision_CPN){
                                delete r.id;
                                return r
                            }
                        })

                        if(content.length > 0){
                            if(this.copyPrevRetain){
                                 this.revision = content[0].revision_number
                            }else{
                                let splitRev = content[0].revision_number.split("-");
                                if(/[a-zA-Z]/.test(splitRev[0])){
                                    this.revision = `${splitRev[0]}-${+splitRev[1]+1}`;
                                }else{
                                    this.revision = this.replaceLetterWithNext(content[0].revision_number);
                                }
                            }
                        }
                        else{
                            if(this.copyPrevRetain){
                                this.revision = this.revision_CPN
                            }else{
                                let splitRev = this.revision_CPN.split("-");
                                if(/[a-zA-Z]/.test(splitRev[0])){
                                    this.revision = `${splitRev[0]}-${+splitRev[1]+1}`;

                                }else{
                                    this.revision = this.replaceLetterWithNext(this.revision_CPN);
                                }
                            }
                        }
                        this.$store.state.cadRequestRevisionContent.revision_type = "9";
                        this.setStandardFormat();
                        break;
                    case '10':
                        this.revision = this.applyNextCad;
                        this.$store.state.cadRequestRevisionContent = {
                                    revision: null,
                                    design_contract: false,
                                    calculation_basis: false,
                                    isBossChecked: null,
                                    site_layout: null,
                                    boss_sending: null,
                                    denki_gravity: null,
                                    gravity_type: null,
                                    gravity: this.cadRequestRevisionContent.gravity,
                                    isHrdCpn :  null,
                                    site_layout_option: null,
                                    site_diagram : null,
                                    new_site_diagram : null,
                                    specs_irai: { 
                                        sash_type: null,  
                                        specs: null,  
                                        accessories: [], 
                                        honeycomb: null, 
                                        },
                                    dxf_data_request: null,
                                    color_pers: null,
                                    house_presentation: null,
                                    house_presentation_int : null,
                                    shio_request: null,
                                    SRS_request: {
                                        shio_selection: null,
                                        shio_number: null,
                                    },
                                    web_documents: null,
                                    jiban_plan: null,
                                    alvs: null,
                                    status: null,
                                    hrd_process: null,
                                    structural_request: null,
                                    pdr: null,
                                    electrical_drawing: null,
                                    cross_section: null,
                                    elevation_section: null,
                                    stop: null,
                                    stopListSelection: null,
                                    final_plan: null,
                                    express: null,
                                    request_attach_from: null,
                                }
                        this.$store.state.cadRequestRevisionContent.revision_type = "10";
                        break;
                }
            }else{
                 let index = this.existingRevisions.length-1;
                switch (this.radio) {
                    case '1':
                            this.revision = 'TEST';
                            // console.log(this.revision, 'rev')
                            this.setStandardFormat();
                        break;
                    case '2':
                        this.revision = 'TEST';
                        this.setStandardFormat();
                        break;
                    case '3':
                        this.revision = 'TEST';
                        this.setStandardFormat();
                        break;
                    case '4':
                        this.revision = 'TEST';
                        this.setStandardFormat();
                        break;
                    case '5':
                            this.revision = 'TEST';
                            this.setStandardFormat();
                        break;
                    case '6':
                        this.revision = 'TEST';
                        this.setStandardFormat();
                        break;
                    case '7':
                        this.revision = 'TEST';
                        break;
                    case '8':
                        this.$store.state.hrdprocessMode = true;
                        this.$store.state.cadRequestRevisionContent.hrd_process = 1;

                        if(this.copyPrev){
                            this.$store.state.cadRequestRevisionContent = {
                                    revision: null,
                                    design_contract: false,
                                    calculation_basis: false,
                                    isBossChecked: null,
                                    site_layout: null,
                                    boss_sending: null,
                                    denki_gravity: null,
                                    gravity_type: this.cadRequestRevisionContent.gravity_type,
                                    gravity: this.cadRequestRevisionContent.gravity,
                                    isHrdCpn : this.cadRequestRevisionContent.isHrdCpn,
                                    site_layout_option: null,
                                    site_diagram : null,
                                    new_site_diagram : null,
                                    specs_irai: { 
                                        sash_type: null,  
                                        specs: null,  
                                        accessories: [], 
                                        honeycomb: null, 
                                        },
                                    dxf_data_request: null,
                                    color_pers: null,
                                    house_presentation: null,
                                    house_presentation_int : null,
                                    shio_request: null,
                                    SRS_request: {
                                        shio_selection: null,
                                        shio_number: null,
                                    },
                                    web_documents: null,
                                    jiban_plan: null,
                                    alvs: null,
                                    status: null,
                                    hrd_process: null,
                                    structural_request: null,
                                    pdr: null,
                                    electrical_drawing: null,
                                    cross_section: null,
                                    elevation_section: null,
                                    stop: null,
                                    stopListSelection: null,
                                    final_plan: null,
                                    express: null,
                                    request_attach_from: null,
                                }
                            this.revision = 'TEST';
                            this.$store.state.cadRequestRevisionContent.design_contract = 1
                            
                            this.$store.state.cadRequestRevisionContent.hrd_process = 1;
                            this.$store.state.cadRequestRevisionContent.express = 1;

                            
                                if(this.$store.state.cadRequestRevisionContent.site_layout == '前回ベースP'){
                                    this.$store.state.cadRequestRevisionContent.new_site_diagram = 'なし'
                                }

                            this.$store.state.existingRevisions.filter((r) => {
                                if(r.revision_number == 'TEST'){
                                    if(r.final_plan == "2" || r.final_plan == "3" || r.final_plan == "1"){
                                        this.$store.state.cadRequestRevisionContent.final_plan = "1";
                                    }
                                }
                            })

                        }else{
                            let splitRev = this.revision_hrdProcess.split('-')

                            if(/[a-zA-Z]/.test(splitRev[0])){
                                this.revision = 'TEST';
                            }else{
                                this.revision = 'TEST';
                            }
                            this.$store.state.existingRevisions.filter((r) => {
                                
                                let dra = []
                                if(r.ED_ELECTRICAL_REQUEST){ 
                                    dra = r.ED_ELECTRICAL_REQUEST.split(', ');
                                }

                                if(r.revision_number == 'TEST'){
                                    if(r.ED_PDR_TITLE == '提案電気図面依頼' || (r.ED_DENKI_PLAN_TITLE == '電気図面依頼' && r.ED_OPTION_1 == 'あり')) {
                                        this.$store.state.electrical_request = {
                                                                                pdr_title : null,
                                                                                radioPdr : null,
                                                                                denki_plan_title : '電気図面依頼',
                                                                                OPTION_1 : 'あり',
                                                                                OPTION_2 : 'あり',
                                                                                radioGravity : '軽微な変更 (S)',
                                                                                selectedDrawing : [],
                                                                            };
                                        this.$store.state.cadRequestRevisionContent.electrical_drawing = this.$store.state.electrical_request;
                                    } else {
                                        this.$store.state.electrical_request = {
                                                                                pdr_title : null,
                                                                                radioPdr : null,
                                                                                denki_plan_title : null,
                                                                                OPTION_1 : null,
                                                                                OPTION_2 : null,
                                                                                radioGravity : null,
                                                                                selectedDrawing : [],
                                                                            };
                                        this.$store.state.cadRequestRevisionContent.electrical_drawing = this.$store.state.electrical_request;
                                    }
                                }

                            })
                            this.copySelectedRevision()
                        }
                        this.$store.state.cadRequestRevisionContent.revision_type = "8";
                        this.$store.state.hrd_process_stamp = true;
                        break;
                    case '9':
                        let content = this.$store.state.existingRevisions.filter((r) => {
                            if(r.revision_number == 'TEST'){
                                delete r.id;
                                return r
                            }
                        })

                        if(content.length > 0){
                            if(this.copyPrevRetain){
                                this.revision = 'TEST'
                            }else{
                                let splitRev = content[0].revision_number.split("-");
                                if(/[a-zA-Z]/.test(splitRev[0])){
                                    this.revision = 'TEST';
                                }else{
                                    this.revision = 'TEST';
                                }
                            }
                        }
                        else{
                            if(this.copyPrevRetain){
                                this.revision = 'TEST'
                            }else{
                                let splitRev = this.revision_CPN.split("-");
                                if(/[a-zA-Z]/.test(splitRev[0])){
                                    this.revision = 'TEST';
                                }else{
                                    this.revision = 'TEST';
                                }
                            }
                        }
                        this.$store.state.cadRequestRevisionContent.revision_type = "9";
                        this.setStandardFormat();
                        break;
                    case '10':
                        this.revision = 'TEST';
                        this.$store.state.cadRequestRevisionContent = {
                                    revision: null,
                                    design_contract: false,
                                    calculation_basis: false,
                                    isBossChecked: null,
                                    site_layout: null,
                                    boss_sending: null,
                                    denki_gravity: null,
                                    gravity_type: null,
                                    gravity: this.cadRequestRevisionContent.gravity,
                                    isHrdCpn :  null,
                                    site_layout_option: null,
                                    site_diagram : null,
                                    new_site_diagram : null,
                                    specs_irai: { 
                                        sash_type: null,  
                                        specs: null,  
                                        accessories: [], 
                                        honeycomb: null, 
                                        },
                                    dxf_data_request: null,
                                    color_pers: null,
                                    house_presentation: null,
                                    house_presentation_int : null,
                                    shio_request: null,
                                    SRS_request: {
                                        shio_selection: null,
                                        shio_number: null,
                                    },
                                    web_documents: null,
                                    jiban_plan: null,
                                    alvs: null,
                                    status: null,
                                    hrd_process: null,
                                    structural_request: null,
                                    pdr: null,
                                    electrical_drawing: null,
                                    cross_section: null,
                                    elevation_section: null,
                                    stop: null,
                                    stopListSelection: null,
                                    final_plan: null,
                                    express: null,
                                    request_attach_from: null,
                                }
                        this.$store.state.cadRequestRevisionContent.revision_type = "10";
                        break;
                }
                // this.revision = 'TEST';
            }

            if(this.$store.state.editMode){
                this.$store.state.editCadRequestRevisionContent.revision_number = this.revision
                this.$emit('toggleDialogRevision', false);
            }else{
                
                if(this.oldRevisions.length > 0 && (this.radio3 == '5Z' || this.radio3 == '5A' || this.radio3 == '5B' || this.radio3 == '5C')){
                    Swal.fire({
                        html: '<div style="text-align: center;font-size:22px;font-weight:bold;">' +
                        '入力した図面番号は既に使用済みです。<br>' +
                        '本物件にて使用されていない図面番号を指示してください。',
                        icon: 'warning',
                        width: 730,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    }).then((result) => {
                        if(result.isConfirmed) {
                            this.radio3 = null
                            return false;
                        }
                    });
                }else if(this.oldRevisions.length == 0 && this.radio3 == '5D') {
                    Swal.fire({
                        html: '<div style="text-align: center;font-size:22px;font-weight:bold;">' +
                        '「図面番号の変更なし」を選択されていますが<br>' +
                        '入力した図面番号のCAD図面は作成されておりません。<br>' +
                        'CAD図面作成済みの図面番号を指示してください。',
                        icon: 'warning',
                        width: 730,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    }).then((result) => {
                        if(result.isConfirmed) {
                            this.radio3 = null
                            return false;
                        }
                    });
                }else{
                    this.$emit('sendDialogRevisionData', this.revision)
                    this.$emit('toggleDialogRevision', false);
                }
                
                // this.$emit('sendDialogRevisionData', this.revision)
                // this.$emit('toggleDialogRevision', false);
                
            }

            // const revisionValue = {
            //     getRadio : this.radio
            // }
        },

        replaceRevision(rev){
            let tempRevision = rev.split("-");
            let str = tempRevision[0].split('');
            var result = "";
            if (str.length >= 1) {
                if (this.isLetter(str[str.length - 1])) {
                    var nextChar = this.getNextLetter(str[str.length - 1]);
                    str[str.length - 1] = nextChar;
                }
                    str = str.join('');
                result = str + '-' + tempRevision[1];
            }else{
                result = `${tempRevision[0]}-${+tempRevision[1] + 1}`
            }
            return result;
        },
        
        replaceLetterWithNext(str) {
            let rev = str.split("-");

            if(/[a-zA-Z]/.test(rev[1])){
                var result = "";
                for (var i = 0; i < rev[1].length; i++) {
                    var currentChar = rev[1].charAt(i);
                    if (this.isLetter(currentChar)) {
                        var nextChar = this.getNextLetter(currentChar);
                        result += nextChar;
                    } else {
                        result += currentChar;
                    }
                }
                return `${rev[0]}-${result}`;
            }else {
                if(this.radio == '9'){
                    return  `${rev[0]}-${+rev[1] + 1}`
                }
                return str + 'A';
            }

        },

        isLetter(char) {
            return /[a-zA-Z]/.test(char);
        },

        getNextLetter(char) {
            var code = char.charCodeAt(0);
            var isUppercase = code >= 65 && code <= 90;
            var isLowercase = code >= 97 && code <= 122;
            if (isUppercase || isLowercase) {
                code = (code - 65 + 1) % 26 + 65;
                if (isLowercase) {
                code += 32;
                }
            }
            return String.fromCharCode(code);
        },

        setStandardFormat(){
            if(this.$store.state.existingRevisions.length > 0){
                    let latestNewRevision = null;
                        if(this.radio != '10') {
                            const existingNewRevisions = this.$store.state.existingRevisions;
                            let getNewLatestIndex = -1;
                            for (let i = existingNewRevisions.length - 1; i >= 0; i--) {
                                if (existingNewRevisions[i].revision_type !== '10') {
                                    getNewLatestIndex = i;
                                    break;
                                }
                            }
                            if (getNewLatestIndex !== -1) {
                                latestNewRevision = existingNewRevisions[getNewLatestIndex];
                                // console.log(latestNewRevision, 'latestNewRevision')
                            } 
                        }

                if(this.$store.state.cadRequestBasicInformation.kakouirai_reason != 5 
                    && this.$store.state.cadRequestBasicInformation.kakouirai_reason != 1 
                    && this.$store.state.cadRequestBasicInformation.kakouirai_reason != 2
                    && this.$store.state.cadRequestBasicInformation.kakouirai_reason == null){

                        if(this.$store.state.existingRevisions[this.$store.state.existingRevisions.length-1].design_contract == 1 || latestNewRevision.design_contract === 1){
                            this.$store.state.cadRequestRevisionContent.design_contract = 1
                        }

                        // IF HOUSE TYPES IS HUGme HUGme Fam and I-Smile II AUTO PHASE 2
                        // if(this.cadRequestBasicInformation.house_type_id == '3' || this.cadRequestBasicInformation.house_type_id == '29' || this.cadRequestBasicInformation.house_type_id == '22') {
                        //     this.$store.state.cadRequestRevisionContent.design_contract = 1
                        // }

                        if(!this.$store.state.editMode) {
                            if(((this.$store.state.existingRevisions[this.$store.state.existingRevisions.length-1].shio_request == 1 && this.$store.state.existingRevisions[this.$store.state.existingRevisions.length-1].revision_type != '10') || latestNewRevision.shio_request == 1)  
                                && (((this.radio == '6' || (this.radio == '5' && this.radio3 == '5D' )) || (this.radio == '8' && this.copyPrev == true) || (this.radio == '9' && this.copyPrevRetain == true))
                                || (this.$store.state.cadRequestBasicInformation.contract_date == null && this.$store.state.cadRequestBasicInformation.provisional_contract_date == null))) {
                                this.$store.state.cadRequestRevisionContent.shio_request = null;
                            } else if(((this.$store.state.existingRevisions[this.$store.state.existingRevisions.length-1].shio_request == 1 && this.$store.state.existingRevisions[this.$store.state.existingRevisions.length-1].revision_type != '10') || latestNewRevision.shio_request == 1) 
                                && (this.radio != '6' || this.radio3 != '5D' || (this.radio != '8' && this.copyPrev != true) || (this.radio != '9' && this.copyPrevRetain != true))) {
                                    // if(!this.$store.state.hokkaidou.includes(this.$store.state.cadRequestBasicInformation.house_type_id)){

                                    // NOTE - CODED 20260623 
                                    // if(!this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || h.hokkaidou == '1') && !this.$store.state.loggedInUser.isHokkaidou_planner)){
                                    // if(!this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || h.hokkaidou == '1') && !this.$store.state.loggedInUser.isHokkaidou_planner)){
                                    
                                    // NOTE - CODED - 20260624 - BY UARY
                                    if(this.$store.state.loggedInUser.isHokkaidou_planner != 1 && this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou != '2' ))){
                                        this.$store.state.cadRequestRevisionContent.shio_request = 1;
                                        // console.log('toyooooo')
                                    // }else if(this.$store.state.hokkaidou.includes(this.$store.state.cadRequestBasicInformation.house_type_id)){

                                    // NOTE - CODED - 20260624 - BY UARY 
                                    }else if(this.$store.state.loggedInUser.isHokkaidou_planner == 1 && !this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || h.hokkaidou == '1'))) {
                                        this.$store.state.cadRequestRevisionContent.shio_request = 1;
                                    }
                                    
                                    else if(this.$store.state.hokkaidou.some(h => h.id === this.$store.state.cadRequestBasicInformation.house_type_id && (h.hokkaidou == '2' || h.hokkaidou == '1'))){
                                        this.$store.state.cadRequestRevisionContent.shio_request = 1; //MODIFIED DEC152025 - UARY
                                        // this.$store.state.cadRequestRevisionContent.shio_request = null; //MODIFIED DEC152025 - UARY
                                        this.$store.state.cadRequestRevisionContent.SRS_request.shio_selection = '1';
                                        // console.log('displayed shio request');
                                    }
                                
                                
                            }
                            // IF PREVIOUS WITHOUT SHIO REQUEST
                            if(((this.$store.state.existingRevisions[this.$store.state.existingRevisions.length-1].shio_request != 1 && this.$store.state.existingRevisions[this.$store.state.existingRevisions.length-1].revision_type != '10') || latestNewRevision.shio_request != 1)  
                                && (this.radio != '6' || this.radio3 != '5D' || (this.radio != '8' && this.copyPrev != true) || (this.radio != '9' && this.copyPrevRetain != true))) {
                                this.$store.state.cadRequestRevisionContent.shio_request = null;
                            }

                            // SSD24-0723783-1434 - SHIO REFERENCE USING 201
                            // if((this.radio == '1' || this.radio == '2' || this.radio == '3' || this.radio == '4') || (this.radio3 == '5Z' || this.radio3 == '5A' || this.radio3 == '5B' || this.radio3 == '5C') 
                            //     && this.$store.state.newShio.length > 0){
                            //     this.$store.state.cadRequestRevisionContent.shio_request = 1
                            // } else {
                            //     this.$store.state.cadRequestRevisionContent.shio_request = null;
                            // }
                            
                            // IF HOUSE TYPES IS HUGme HUGme Fam and I-Smile II AUTO PHASE 2
                            // if(this.cadRequestBasicInformation.house_type_id == '3' || this.cadRequestBasicInformation.house_type_id == '29' || this.cadRequestBasicInformation.house_type_id == '22') {
                            //     this.$store.state.cadRequestRevisionContent.design_contract = 1
                            // }

                            if(this.radio == '6' || this.radio3 == '5D' || (this.radio == '9' && this.copyPrevRetain == true) || (this.radio == '8' && this.copyPrev == true) 
                                || ((this.$store.state.existingRevisions[this.$store.state.existingRevisions.length-1].site_layout == null && this.$store.state.existingRevisions[this.$store.state.existingRevisions.length-1].revision_type != '10') || latestNewRevision.site_layout == null)){
                                this.$store.state.cadRequestRevisionContent.site_layout = null;
                            } else {
                                this.$store.state.cadRequestRevisionContent.site_layout = '前回ベースP';
                                if(this.$store.state.cadRequestRevisionContent.site_layout == '前回ベースP'){
                                    this.$store.state.cadRequestRevisionContent.new_site_diagram = 'なし'
                                }
                            }

                            // SSD24-0723783-1435 - SITE REFERENCE USING 004 
                            // if((this.radio == '1' || this.radio == '2' || this.radio == '3' || this.radio == '4') || (this.radio3 == '5Z' || this.radio3 == '5A' || this.radio3 == '5B' || this.radio3 == '5C') 
                            //     && this.$store.state.newSite.length > 0){
                            //     this.$store.state.cadRequestRevisionContent.site_layout = '前回ベースP';
                            //     if(this.$store.state.cadRequestRevisionContent.site_layout == '前回ベースP'){
                            //         this.$store.state.cadRequestRevisionContent.new_site_diagram = 'なし'
                            //     }
                            // } else {
                            //     this.$store.state.cadRequestRevisionContent.site_layout = null;
                            // }

                            // if(this.radio == '6' || this.radio3 == '5D' || (this.radio == '9' && this.copyPrevRetain == true) || (this.radio == '8' && this.copyPrev == true) 
                            //     || (this.$store.state.newSite.length == 0 || latestNewRevision.site_layout == null)){
                            //     console.log(this.$store.state.newSite, '111')
                            //     this.$store.state.cadRequestRevisionContent.site_layout = null;
                            // } else {
                            //     console.log('2')
                            //     this.$store.state.cadRequestRevisionContent.site_layout = '前回ベースP';
                            //     if(this.$store.state.cadRequestRevisionContent.site_layout == '前回ベースP'){
                            //         this.$store.state.cadRequestRevisionContent.new_site_diagram = 'なし'
                            //     }
                            // }

                            if(this.radio == '7') {
                                this.$store.state.cadRequestRevisionContent.shio_request = null;
                            }
                        } else {
                            if(((this.$store.state.existingRevisions[this.$store.state.existingRevisions.length-1].shio_request == 1 && this.$store.state.existingRevisions[this.$store.state.existingRevisions.length-1].revision_type != '10') || latestNewRevision.shio_request == 1) 
                                && (((this.radio == '6' || (this.radio == '5' && this.radio3 == '5D' )) || (this.radio == '8' && this.copyPrev == true) || (this.radio == '9' && this.copyPrevRetain == true))
                                || (this.$store.state.cadRequestBasicInformation.contract_date == null && this.$store.state.cadRequestBasicInformation.provisional_contract_date == null))) {
                                this.$store.state.editCadRequestRevisionContent.shio_request = null;
                            } else if(((this.$store.state.existingRevisions[this.$store.state.existingRevisions.length-1].shio_request == 1 && this.$store.state.existingRevisions[this.$store.state.existingRevisions.length-1].revision_type != '10') || latestNewRevision.shio_request == 1)
                                && (this.radio != '6' || this.radio3 != '5D' || (this.radio != '8' && this.copyPrev != true) || (this.radio != '9' && this.copyPrevRetain != true))) {
                                this.$store.state.editCadRequestRevisionContent.shio_request = 1;
                            }
                            // IF PREVIOUS WITHOUT SHIO REQUEST
                            if(((this.$store.state.existingRevisions[this.$store.state.existingRevisions.length-1].shio_request != 1 && this.$store.state.existingRevisions[this.$store.state.existingRevisions.length-1].revision_type != '10') || latestNewRevision.shio_request != 1)    
                                && (this.radio != '6' || this.radio3 != '5D' || (this.radio != '8' && this.copyPrev != true) || (this.radio != '9' && this.copyPrevRetain != true))) {
                                this.$store.state.editCadRequestRevisionContent.shio_request = null;
                            }

                            // SSD24-0723783-1434 - SHIO REFERENCE USING 201
                            // if((this.radio == '1' || this.radio == '2' || this.radio == '3' || this.radio == '4') || (this.radio3 == '5Z' || this.radio3 == '5A' || this.radio3 == '5B' || this.radio3 == '5C') 
                            //     && this.$store.state.newShio.length > 0){
                            //     this.$store.state.editCadRequestRevisionContent.shio_request = 1
                            // } else {
                            //     this.$store.state.editCadRequestRevisionContent.shio_request = null;
                            // }

                            // IF HOUSE TYPES IS HUGme HUGme Fam and I-Smile II AUTO PHASE 2
                            // if(this.cadRequestBasicInformation.house_type_id == '3' || this.cadRequestBasicInformation.house_type_id == '29' || this.cadRequestBasicInformation.house_type_id == '22') {
                            //     this.$store.state.editCadRequestRevisionContent.design_contract = 1
                            // }

                            if(this.radio == '6' || this.radio3 == '5D' || (this.radio == '9' && this.copyPrevRetain == true) || (this.radio == '8' && this.copyPrev == true) 
                                || ((this.$store.state.existingRevisions[this.$store.state.existingRevisions.length-1].site_layout == null && this.$store.state.existingRevisions[this.$store.state.existingRevisions.length-1].revision_type != '10') || latestNewRevision.site_layout == null)){
                                this.$store.state.editCadRequestRevisionContent.site_layout = null;
                            } else {
                                this.$store.state.editCadRequestRevisionContent.site_layout = '前回ベースP';
                                if(this.$store.state.editCadRequestRevisionContent.site_layout == '前回ベースP'){
                                    this.$store.state.editCadRequestRevisionContent.new_site_diagram = 'なし'
                                }
                            }

                             // SSD24-0723783-1435 - SITE REFERENCE USING 004
                            // if((this.radio == '1' || this.radio == '2' || this.radio == '3' || this.radio == '4') || (this.radio3 == '5Z' || this.radio3 == '5A' || this.radio3 == '5B' || this.radio3 == '5C') 
                            //     && this.$store.state.newSite.length > 0){
                            //     this.$store.state.editCadRequestRevisionContent.site_layout = '前回ベースP';
                            //     if(this.$store.state.editCadRequestRevisionContent.site_layout == '前回ベースP'){
                            //         this.$store.state.editCadRequestRevisionContent.new_site_diagram = 'なし'
                            //     }
                            // } else {
                            //     this.$store.state.editCadRequestRevisionContent.site_layout = null;
                            // }

                            // if(this.radio == '6' || this.radio3 == '5D' || (this.radio == '9' && this.copyPrevRetain == true) || (this.radio == '8' && this.copyPrev == true) 
                            //     || (this.$store.state.newSite == null || latestNewRevision.site_layout == null)){
                            //     this.$store.state.editCadRequestRevisionContent.site_layout = null;
                            // } else {
                            //     this.$store.state.editCadRequestRevisionContent.site_layout = '前回ベースP';
                            //     if(this.$store.state.editCadRequestRevisionContent.site_layout == '前回ベースP'){
                            //         this.$store.state.editCadRequestRevisionContent.new_site_diagram = 'なし'
                            //     }
                            // }

                            if(this.radio == '7') {
                                this.$store.state.cadRequestRevisionContent.shio_request = null;
                            }
                        }
                        
                        // OLD CONDITION
                        // if(this.$store.state.existingRevisions[this.$store.state.existingRevisions.length-1].site_layout != null){
                        //     if(this.radio == '6' || this.radio3 == '5D' || (this.radio == '9' && this.copyPrevRetain == true) || (this.radio == '8' && this.copyPrev == true)){
                        //         this.$store.state.cadRequestRevisionContent.site_layout = null;
                        //     } else {
                        //         this.$store.state.cadRequestRevisionContent.site_layout = '前回ベースP';
                        //         if(this.$store.state.cadRequestRevisionContent.site_layout == '前回ベースP'){
                        //             this.$store.state.cadRequestRevisionContent.new_site_diagram = 'なし'
                        //         }
                        //     }

                        //     if(this.radio == '6' || this.radio3 == '5D' || (this.radio == '9' && this.copyPrevRetain == true) || (this.radio == '8' && this.copyPrev == true)){
                        //         this.$store.state.editCadRequestRevisionContent.site_layout = null;
                        //     } else {
                        //         this.$store.state.editCadRequestRevisionContent.site_layout = '前回ベースP';
                        //         if(this.$store.state.editCadRequestRevisionContent.site_layout == '前回ベースP'){
                        //             this.$store.state.editCadRequestRevisionContent.new_site_diagram = 'なし'
                        //         }
                        //     }
                        //     // this.$store.state.cadRequestRevisionContent.site_layout = null;
                        // } else {
                        //     if(this.radio == '6' || this.radio3 == '5D' || (this.radio == '9' && this.copyPrevRetain == true) || (this.radio == '8' && this.copyPrev == true)){
                        //         this.$store.state.cadRequestRevisionContent.site_layout = null;
                        //     } else {
                        //         this.$store.state.cadRequestRevisionContent.site_layout = '前回ベースP';
                        //         if(this.$store.state.cadRequestRevisionContent.site_layout == '前回ベースP'){
                        //             this.$store.state.cadRequestRevisionContent.new_site_diagram = 'なし'
                        //         }
                        //     }

                        //     if(this.radio == '6' || this.radio3 == '5D' || (this.radio == '9' && this.copyPrevRetain == true) || (this.radio == '8' && this.copyPrev == true)){
                        //         this.$store.state.editCadRequestRevisionContent.site_layout = null;
                        //     } else {
                        //         this.$store.state.editCadRequestRevisionContent.site_layout = '前回ベースP';
                        //         if(this.$store.state.editCadRequestRevisionContent.site_layout == '前回ベースP'){
                        //             this.$store.state.editCadRequestRevisionContent.new_site_diagram = 'なし'
                        //         }
                        //     }
                        // }
                        // if(this.radio == '6' || (this.radio == '5' && this.radio3 == '5D' ) || (this.radio == '8' && this.copyPrev == true) || (this.radio == '9' && this.copyPrevRetain == true)){
                        //     this.$store.state.cadRequestRevisionContent.shio_request = null;
                            // POP UP SRS SELECTION
                            // this.$emit('toggleDialogShioRequest', true);
                        // } else {
                        //     this.$store.state.cadRequestRevisionContent.shio_request = 1;
                        // }

                        if(this.$store.state.existingRevisions[this.$store.state.existingRevisions.length-1].final_plan == '1' ||
                            this.$store.state.existingRevisions[this.$store.state.existingRevisions.length-1].final_plan == '2' || 
                            this.$store.state.existingRevisions[this.$store.state.existingRevisions.length-1].final_plan == '3') {
                            this.$store.state.cadRequestRevisionContent.final_plan = '1';
                            this.$store.state.editFinalPlan = '1';
                        }
                    }else{
                        if(!this.$store.state.editMode) {
                            if(((this.$store.state.existingRevisions[this.$store.state.existingRevisions.length-1].shio_request == 1 && this.$store.state.existingRevisions[this.$store.state.existingRevisions.length-1].revision_type != '10') || latestNewRevision.shio_request == 1)  
                                && (((this.radio == '6' || (this.radio == '5' && this.radio3 == '5D' )) || (this.radio == '8' && this.copyPrev == true) || (this.radio == '9' && this.copyPrevRetain == true))
                                || (this.$store.state.cadRequestBasicInformation.contract_date == null && this.$store.state.cadRequestBasicInformation.provisional_contract_date == null))) {
                                this.$store.state.cadRequestRevisionContent.shio_request = null;
                            } else if(((this.$store.state.existingRevisions[this.$store.state.existingRevisions.length-1].shio_request == 1 && this.$store.state.existingRevisions[this.$store.state.existingRevisions.length-1].revision_type != '10') || latestNewRevision.shio_request == 1) 
                                && (this.radio != '6' || this.radio3 != '5D' || (this.radio != '8' && this.copyPrev != true) || (this.radio != '9' && this.copyPrevRetain != true))) {
                                this.$store.state.cadRequestRevisionContent.shio_request = 1;
                            }
                            // IF PREVIOUS WITHOUT SHIO REQUEST
                            if(((this.$store.state.existingRevisions[this.$store.state.existingRevisions.length-1].shio_request != 1 && this.$store.state.existingRevisions[this.$store.state.existingRevisions.length-1].revision_type != '10') || latestNewRevision.shio_request != 1) 
                                && (this.radio != '6' || this.radio3 != '5D' || (this.radio != '8' && this.copyPrev != true) || (this.radio != '9' && this.copyPrevRetain != true))) {
                                this.$store.state.cadRequestRevisionContent.shio_request = null;
                            }

                            // SSD24-0723783-1434 - SHIO REFERENCE USING 201
                            // if((this.radio == '1' || this.radio == '2' || this.radio == '3' || this.radio == '4') || (this.radio3 == '5Z' || this.radio3 == '5A' || this.radio3 == '5B' || this.radio3 == '5C') 
                            //     && this.$store.state.newShio.length > 0){
                            //     this.$store.state.cadRequestRevisionContent.shio_request = 1
                            // } else {
                            //     this.$store.state.cadRequestRevisionContent.shio_request = null;
                            // }

                            // IF HOUSE TYPES IS HUGme HUGme Fam and I-Smile II AUTO PHASE 2
                            // if(this.cadRequestBasicInformation.house_type_id == '3' || this.cadRequestBasicInformation.house_type_id == '29' || this.cadRequestBasicInformation.house_type_id == '22') {
                            //     this.$store.state.cadRequestRevisionContent.design_contract = 1
                            // }

                            // if(this.radio == '6' || this.radio3 == '5D' || (this.radio == '8' && this.copyPrev == true) || (this.radio == '9' && this.copyPrevRetain == true)){
                            //     this.$store.state.cadRequestRevisionContent.shio_request = null;
                            //     // POP UP SRS SELECTION
                            //     this.$emit('toggleDialogShioRequest', true);
                            // } else {
                            //     this.$store.state.cadRequestRevisionContent.shio_request = 1;
                            // }
                            
                            if(this.radio == '6' || this.radio3 == '5D' || (this.radio == '9' && this.copyPrevRetain == true) || (this.radio == '8' && this.copyPrev == true) 
                                || ((this.$store.state.existingRevisions[this.$store.state.existingRevisions.length-1].site_layout == null && this.$store.state.existingRevisions[this.$store.state.existingRevisions.length-1].revision_type != '10') || latestNewRevision.site_layout == null)){
                                this.$store.state.cadRequestRevisionContent.site_layout = null;
                            } else {
                                this.$store.state.cadRequestRevisionContent.site_layout = '前回ベースP';
                                if(this.$store.state.cadRequestRevisionContent.site_layout == '前回ベースP'){
                                    this.$store.state.cadRequestRevisionContent.new_site_diagram = 'なし'
                                }
                            }

                             // SSD24-0723783-1435 - SITE REFERENCE USING 004
                            // if((this.radio == '1' || this.radio == '2' || this.radio == '3' || this.radio == '4') || (this.radio3 == '5Z' || this.radio3 == '5A' || this.radio3 == '5B' || this.radio3 == '5C') 
                            //     && this.$store.state.newSite.length > 0){
                            //     this.$store.state.cadRequestRevisionContent.site_layout = '前回ベースP';
                            //     if(this.$store.state.cadRequestRevisionContent.site_layout == '前回ベースP'){
                            //         this.$store.state.cadRequestRevisionContent.new_site_diagram = 'なし'
                            //     }
                            // } else {
                            //     this.$store.state.cadRequestRevisionContent.site_layout = null;
                            // }
                            
                            // if(this.radio == '6' || this.radio3 == '5D' || (this.radio == '9' && this.copyPrevRetain == true) || (this.radio == '8' && this.copyPrev == true) 
                            //     || (this.$store.state.newSite == null || latestNewRevision.site_layout == null)){
                            //     this.$store.state.cadRequestRevisionContent.site_layout = null;
                            // } else {
                            //     this.$store.state.cadRequestRevisionContent.site_layout = '前回ベースP';
                            //     if(this.$store.state.cadRequestRevisionContent.site_layout == '前回ベースP'){
                            //         this.$store.state.cadRequestRevisionContent.new_site_diagram = 'なし'
                            //     }
                            // }

                            if(this.radio == '7') {
                                this.$store.state.cadRequestRevisionContent.shio_request = null;
                            }
                        } else {
                            if(((this.$store.state.existingRevisions[this.$store.state.existingRevisions.length-1].shio_request == 1 && this.$store.state.existingRevisions[this.$store.state.existingRevisions.length-1].revision_type != '10') || latestNewRevision.shio_request == 1)   
                                && (((this.radio == '6' || (this.radio == '5' && this.radio3 == '5D' )) || (this.radio == '8' && this.copyPrev == true) || (this.radio == '9' && this.copyPrevRetain == true))
                                || (this.$store.state.cadRequestBasicInformation.contract_date == null && this.$store.state.cadRequestBasicInformation.provisional_contract_date == null))) {
                                this.$store.state.editCadRequestRevisionContent.shio_request = null;
                            } else if(((this.$store.state.existingRevisions[this.$store.state.existingRevisions.length-1].shio_request == 1 && this.$store.state.existingRevisions[this.$store.state.existingRevisions.length-1].revision_type != '10') || latestNewRevision.shio_request == 1)  
                                && (this.radio != '6' || this.radio3 != '5D' || (this.radio != '8' && this.copyPrev != true) || (this.radio != '9' && this.copyPrevRetain != true))) {
                                this.$store.state.editCadRequestRevisionContent.shio_request = 1;
                            }
                            // IF PREVIOUS WITHOUT SHIO REQUEST
                            if(((this.$store.state.existingRevisions[this.$store.state.existingRevisions.length-1].shio_request != 1 && this.$store.state.existingRevisions[this.$store.state.existingRevisions.length-1].revision_type != '10') || latestNewRevision.shio_request != 1)
                                && (this.radio != '6' || this.radio3 != '5D' || (this.radio != '8' && this.copyPrev != true) || (this.radio != '9' && this.copyPrevRetain != true))) {
                                this.$store.state.editCadRequestRevisionContent.shio_request = null;
                            }

                            // SSD24-0723783-1434 - SHIO REFERENCE USING 201
                            // if((this.radio == '1' || this.radio == '2' || this.radio == '3' || this.radio == '4') || (this.radio3 == '5Z' || this.radio3 == '5A' || this.radio3 == '5B' || this.radio3 == '5C') 
                            //     && this.$store.state.newShio.length > 0){
                            //     this.$store.state.editCadRequestRevisionContent.shio_request = 1
                            // } else {
                            //     this.$store.state.editCadRequestRevisionContent.shio_request = null;
                            // }

                            // IF HOUSE TYPES IS HUGme HUGme Fam and I-Smile II AUTO PHASE 2
                            // if(this.cadRequestBasicInformation.house_type_id == '3' || this.cadRequestBasicInformation.house_type_id == '29' || this.cadRequestBasicInformation.house_type_id == '22') {
                            //     this.$store.state.editCadRequestRevisionContent.design_contract = 1
                            // }

                            if(this.radio == '6' || this.radio3 == '5D' || (this.radio == '9' && this.copyPrevRetain == true) || (this.radio == '8' && this.copyPrev == true) 
                                || ((this.$store.state.existingRevisions[this.$store.state.existingRevisions.length-1].site_layout == null && this.$store.state.existingRevisions[this.$store.state.existingRevisions.length-1].revision_type != '10') || latestNewRevision.site_layout == null)){
                                this.$store.state.editCadRequestRevisionContent.site_layout = null;
                            } else {
                                this.$store.state.editCadRequestRevisionContent.site_layout = '前回ベースP';
                                if(this.$store.state.editCadRequestRevisionContent.site_layout == '前回ベースP'){
                                    this.$store.state.editCadRequestRevisionContent.new_site_diagram = 'なし'
                                }
                            }

                             // SSD24-0723783-1435 - SITE REFERENCE USING 004
                            // if((this.radio == '1' || this.radio == '2' || this.radio == '3' || this.radio == '4') || (this.radio3 == '5Z' || this.radio3 == '5A' || this.radio3 == '5B' || this.radio3 == '5C') 
                            //     && this.$store.state.newSite.length > 0){
                            //     this.$store.state.editCadRequestRevisionContent.site_layout = '前回ベースP';
                            //     if(this.$store.state.editCadRequestRevisionContent.site_layout == '前回ベースP'){
                            //         this.$store.state.editCadRequestRevisionContent.new_site_diagram = 'なし'
                            //     }
                            // } else {
                            //     this.$store.state.editCadRequestRevisionContent.site_layout = null;
                            // }


                            // if(this.radio == '6' || this.radio3 == '5D' || (this.radio == '9' && this.copyPrevRetain == true) || (this.radio == '8' && this.copyPrev == true) 
                            //     || (this.$store.state.newSite == null || latestNewRevision.site_layout == null)){
                            //     this.$store.state.editCadRequestRevisionContent.site_layout = null;
                            // } else {
                            //     this.$store.state.editCadRequestRevisionContent.site_layout = '前回ベースP';
                            //     if(this.$store.state.editCadRequestRevisionContent.site_layout == '前回ベースP'){
                            //         this.$store.state.editCadRequestRevisionContent.new_site_diagram = 'なし'
                            //     }
                            // }

                            if(this.radio == '7') {
                                this.$store.state.cadRequestRevisionContent.shio_request = null;
                            }
                        }
                        // OLD CONDITION
                        // if(this.$store.state.existingRevisions[this.$store.state.existingRevisions.length-1].site_layout != null){
                        //     if(this.radio == '6' || this.radio3 == '5D' || (this.radio == '9' && this.copyPrevRetain == true) || (this.radio == '8' && this.copyPrev == true)){
                        //         this.$store.state.cadRequestRevisionContent.site_layout = null;
                        //     } else {
                        //         this.$store.state.cadRequestRevisionContent.site_layout = '前回ベースP';
                        //         if(this.$store.state.cadRequestRevisionContent.site_layout == '前回ベースP'){
                        //             this.$store.state.cadRequestRevisionContent.new_site_diagram = 'なし'
                        //         }
                        //     }

                        //     if(this.radio == '6' || this.radio3 == '5D' || (this.radio == '9' && this.copyPrevRetain == true) || (this.radio == '8' && this.copyPrev == true)){
                        //         this.$store.state.editCadRequestRevisionContent.site_layout = null;
                        //     } else {
                        //         this.$store.state.editCadRequestRevisionContent.site_layout = '前回ベースP';
                        //         if(this.$store.state.editCadRequestRevisionContent.site_layout == '前回ベースP'){
                        //             this.$store.state.editCadRequestRevisionContent.new_site_diagram = 'なし'
                        //         }
                        //     }
                        //     // this.$store.state.cadRequestRevisionContent.site_layout = null;
                        // } else {
                        //     if(this.radio == '6' || this.radio3 == '5D' || (this.radio == '9' && this.copyPrevRetain == true) || (this.radio == '8' && this.copyPrev == true)){
                        //         this.$store.state.cadRequestRevisionContent.site_layout = null;
                        //     } else {
                        //         this.$store.state.cadRequestRevisionContent.site_layout = '前回ベースP';
                        //         if(this.$store.state.cadRequestRevisionContent.site_layout == '前回ベースP'){
                        //             this.$store.state.cadRequestRevisionContent.new_site_diagram = 'なし'
                        //         }
                        //     }

                        //     if(this.radio == '6' || this.radio3 == '5D' || (this.radio == '9' && this.copyPrevRetain == true) || (this.radio == '8' && this.copyPrev == true)){
                        //         this.$store.state.editCadRequestRevisionContent.site_layout = null;
                        //     } else {
                        //         this.$store.state.editCadRequestRevisionContent.site_layout = '前回ベースP';
                        //         if(this.$store.state.editCadRequestRevisionContent.site_layout == '前回ベースP'){
                        //             this.$store.state.editCadRequestRevisionContent.new_site_diagram = 'なし'
                        //         }
                        //     }
                        // }
                }
            }
            this.$store.state.cadRequestRevisionContent.electrical_drawing = [];
            // console.log(this.$store.state.existingRevisions,'existings')

        },
        copySelectedRevision(){
            // let prevDenki = this.$store.state.existingRevisions[this.$store.state.existingRevisions.length - 1];
            // console.log(prevDenki,'previous')
            let content = this.$store.state.existingRevisions.filter((r) => {
                if(r.revision_number == this.revision_hrdProcess){
                    delete r.id;
                    return r
                }
            })
            // console.log(content[0], 'content')
            this.$store.state.cadRequestRevisionContent = {...content[0]}
            this.$store.state.attachments = [];
            // console.log(this.$store.state.cadRequestRevisionContent, 'rev')
            this.$store.state.alvsSelection = content[0].alvs

            // this.$store.state.cadRequestRevisionContent.SRS_request = null; // for Confirmation
            this.$store.state.cadRequestRevisionContent.SRS_request = {
                                                                        shio_selection: null,
                                                                        shio_number: null,
                                                                    }
            // this.$store.state.cadRequestRevisionContent.shio_request = null; // for Confirmation
            // this.$store.state.cadRequestRevisionContent.shio_request = content[0].shio_request;

            // NOTE : FINAL PLAN
            if(content[0].revision_number == this.revision_hrdProcess){
                if(content[0].final_plan == "2" || content[0].final_plan == "3" || content[0].final_plan == "1"){
                    this.$store.state.cadRequestRevisionContent.final_plan = "1";
                }  
            }

            // NOTE : HRD PROCESS WITH PREVIOUS SITE LAYOUT
            if(content[0].site_layout == '新規データN') {
                this.$store.state.cadRequestRevisionContent.site_layout = '前回ベースP'
                this.$store.state.cadRequestRevisionContent.new_site_diagram = 'なし'
            }

            // NOTE : STRUCTURAL REQUEST
            this.$store.state.structural_request = {
                    OPTION_1 : content[0].SR_OPTION_1,
                    OPTION_2 : content[0].SR_OPTION_2,
                    OPTION_ZEH : content[0].SR_OPTION_ZEH,
                    OPTION_GX : content[0].SR_OPTION_GX,
                    OPTION_W : content[0].SR_OPTION_W,
                    OPTION_S : content[0].SR_OPTION_S,
            };

            // NOTE : ELECTRICAL DRAWING
            // let dra = []
            //     if(content[0].ED_ELECTRICAL_REQUEST){
            //         dra = content[0].ED_ELECTRICAL_REQUEST.split(', ');
            //     }
            if(content[0].ED_PDR_TITLE == '提案電気図面依頼' || (content[0].ED_DENKI_PLAN_TITLE == '電気図面依頼' && content[0].ED_OPTION_1 == 'あり')) {
                this.$store.state.electrical_request = {
                                                        pdr_title : null,
                                                        radioPdr : null,
                                                        denki_plan_title : '電気図面依頼',
                                                        OPTION_1 : 'あり',
                                                        OPTION_2 : 'あり',
                                                        radioGravity : '軽微な変更 (S)',
                                                        selectedDrawing : [],
                                                    };
                this.$store.state.cadRequestRevisionContent.electrical_drawing = this.$store.state.electrical_request;
            } else {
                this.$store.state.electrical_request = {
                                                        pdr_title : null,
                                                        radioPdr : null,
                                                        denki_plan_title : null,
                                                        OPTION_1 : null,
                                                        OPTION_2 : null,
                                                        radioGravity : null,
                                                        selectedDrawing : [],
                                                    };
                this.$store.state.cadRequestRevisionContent.electrical_drawing = this.$store.state.electrical_request;
            }
                

                // if(content[0].ED_DENKI_PLAN_TITLE == null && content[0].ED_OPTION_1 == null){
                //     this.$store.state.electrical_request = {
                //                                                 pdr_title : null,
                //                                                 radioPdr : null,
                //                                                 denki_plan_title : null,
                //                                                 OPTION_1 : null,
                //                                                 OPTION_2 : null,
                //                                                 radioGravity : null,
                //                                                 selectedDrawing : [],
                //                                                 // radioGravity : content[0].ED_DENKI_PLAN_GRAVITY,
                //                                                 // selectedDrawing : dra,
                //                                             };
                //     this.$store.state.cadRequestRevisionContent.electrical_drawing = this.$store.state.electrical_request;
                // }
                // if(content[0].ED_DENKI_PLAN_TITLE != null && content[0].ED_OPTION_1 != null  && content[0].ED_OPTION_2 != null){
                //     this.$store.state.electrical_request = {
                //                                                 pdr_title : null,
                //                                                 radioPdr : null,
                //                                                 denki_plan_title : content[0].ED_DENKI_PLAN_TITLE,
                //                                                 OPTION_1 : content[0].ED_OPTION_1,
                //                                                 OPTION_2 : content[0].ED_OPTION_2,
                //                                                 radioGravity : content[0].ED_DENKI_PLAN_GRAVITY,
                //                                                 selectedDrawing : dra,
                //                                             };
                //     this.$store.state.cadRequestRevisionContent.electrical_drawing = this.$store.state.electrical_request;
                // } 
                // if(content[0].ED_DENKI_PLAN_TITLE != null && content[0].ED_OPTION_1 != null && content[0].ED_OPTION_2 && content[0].ED_ELECTRICAL_REQUEST == null) {
                //     this.$store.state.electrical_request = {
                //                                                 pdr_title : null,
                //                                                 radioPdr : null,
                //                                                 denki_plan_title : content[0].ED_DENKI_PLAN_TITLE,
                //                                                 OPTION_1 : content[0].ED_OPTION_1,
                //                                                 OPTION_2 : content[0].ED_OPTION_2,
                //                                                 radioGravity : content[0].ED_DENKI_PLAN_GRAVITY,
                //                                                 selectedDrawing : [],
                //                                             }
                // }
                // if(content[0].ED_PDR_TITLE != null && content[0].ED_DENKI_PLAN_1 != 'なし') {
                //     this.$store.state.electrical_request = {
                //                                                 pdr_title : content[0].ED_PDR_TITLE,
                //                                                 radioPdr: content[0].ED_DENKI_PLAN_1,
                //                                                 denki_plan_title : null,
                //                                                 OPTION_1 : null,
                //                                                 OPTION_2 : null,
                //                                                 radioGravity : null,
                //                                                 selectedDrawing : [],
                //                                             };
                //     this.$store.state.cadRequestRevisionContent.electrical_drawing = this.$store.state.electrical_request;
                // }

            // if(content[0].ED_DENKI_PLAN_TITLE != null && content[0].ED_OPTION_1 == "あり" && content[0].ED_OPTION_2 == "あり") {
            //     this.$store.state.electrical_request = {
            //                                                 pdr_title : null,
            //                                                 radioPdr : null,
            //                                                 denki_plan_title : content[0].ED_DENKI_PLAN_TITLE,
            //                                                 OPTION_1 : 'あり',
            //                                                 OPTION_2 : 'あり',
            //                                                 radioGravity : content[0].ED_DENKI_PLAN_GRAVITY,
            //                                                 selectedDrawing : dra,
            //                                             };
            //     this.$store.state.cadRequestRevisionContent.electrical_drawing = this.$store.state.electrical_request;
            // } 
            // this.$store.state.electrical_request = {
            //     OPTION_1 : content[0].ED_OPTION_1,
            //     OPTION_2 : content[0].ED_OPTION_2,
            // };

            this.$store.state.cadRequestRevisionContent.structural_request = this.$store.state.structural_request;
            this.$store.state.cadRequestRevisionContent.electrical_drawing = this.$store.state.electrical_request;
            this.$store.state.cadRequestRevisionContent.hrd_process = 1;
            this.$store.state.cadRequestRevisionContent.express = 1;
            this.$store.state.cadRequestRevisionContent.denki_gravity = content[0].denki_plan_gravity;

            this.$store.state.cadRequestRevisionContent.cross_section = content[0].cross_section;
            this.$store.state.cadRequestRevisionContent.elevation_section = content[0].elevation_section;

            // this.$store.state.cadRequestColorPers = content[0].color_perspective ? content[0].color_perspective : null;
            // this.$store.state.cadRequestRevisionContent.structural_request = this.$store.state.structural_request

            if(content[0].color_perspective){
                this.$store.state.cadRequestColorPers = []
                if(content[0].color_perspective.length > 0){
                    content[0].color_perspective.forEach(element => {
                        // console.log(element, 'element')
                        let color = {
                            is_request_color_info: element.is_request_color_info,
                            roof: {
                                    roofing_material: null,
                                    roof_color: element.roof ? element.roof : null,
                                },
                            spray_1f: {
                                exteriorRequestContent: element.spray_1f != null ? element.spray_1f : null,
                                },
                            spray_2f: {
                                exteriorRequestContent: element.spray_2f != null ? element.spray_2f : null,
                                },
                            spray_3f: {
                                exteriorRequestContent: element.spray_3f != null ? element.spray_3f : null,
                                },
                            exterior_wall_tile : {
                                // color_construction: element.exterior_wall_tile ? element.color_construction : null,
                                exterior_wall_tile: element.exterior_wall_tile ? element.exterior_wall_tile : null,
                                accent_wall_color: element.accent_wall_color ? element.accent_wall_color : null,
                                },
                            external_wall_finish : element.external_wall_finish,
                            balcony_glass : element.balcony_glass,
                            design_louver : element.design_louver,
                            sash : element.sash,
                            front_door : {
                                    entrance_door_type: null,
                                    door_item: null,
                                    door_color: element.front_door ? element.front_door : null,
                                },
                            mall_and_arrowhead_decoration : element.mall_and_arrowhead_decoration,
                            balcony_belt : element.balcony_belt,
                            tile_band : element.tile_band,
                            decorative_belt_1f : element.decorative_belt_1f,
                            decorative_belt_2f : element.decorative_belt_2f,
                            eaves_of_a_house : element.eaves_of_a_house,
                            eaves_gutter : element.eaves_gutter,
                            breaking_wind : element.breaking_wind,
                            base_draining : element.base_draining,
                            porch_tile : {
                                porch_tile_item: null,
                                porch_tile_item_color: element.porch_tile ? element.porch_tile : null,
                            },
                            perspective_direction : element.perspective_direction,
                            viewpoint_height : element.viewpoint_height,
                            garden_number : element.garden_number,
                        }
                        this.$store.state.cadRequestColorPers.push(color)
                    });
                }
            }
                console.log(this.cadRequestColorPers, 'color')
            this.$store.state.cadRequestRevisionContent.color_perspective = this.cadRequestColorPers;

            if(!content[0].specs_irai){
                this.$store.state.cadRequestRevisionContent.specs_irai = { 
                    sash_type: null,  
                    specs: null,  
                    accessories: [],
                    honeycomb: null,  
                };  
            }
            else{
                this.$store.state.cadRequestRevisionContent.specs_irai = { 
                    sash_type: content[0].specs_irai.sash_type,  
                    specs: content[0].specs_irai.specs,  
                    accessories : content[0].specs_irai.accessories,
                    honeycomb : content[0].specs_irai.honeycomb,
                };
            }
            if(content[0].stop_list.length > 0){
                this.$store.state.cadRequestRevisionContent.stopListSelection = content[0].stop_list.filter((res) => {
                                                                                        res.option1 = res.OPTION_1;
                                                                                        res.option2 = res.OPTION_2;
                                                                                        res.isChecked = res.isChecked;
                                                                                        res.selected = res.SELECTED;
                                                                                        res.category = res.category;
                                                                                        res.rowCount = res.rowCount;
                                                                                        return res;
                                                                                    })  
            }else{
                this.$store.state.cadRequestRevisionContent.stopListSelection = null
            }
            this.$store.state.cadRequestRevisionContent.stop = null;
            this.$store.state.cadRequestRevisionContent.status = null;
            // console.log(this.$store.state.cadRequestRevisionContent, 'this.$store.state.cadRequestRevisionContent')
        },
    },


    watch: {
        "$store.state.cadRequestBasicInformation"(val){
            this.$store.state.getHouseId = val.house_type_id;
            // console.log(this.$store.state.getHouseId,'this.$store.state.getHouseId')
            let withCheck = /^(0009999)/;
            let defaultWithCheck = /^(SA)/;

            if(val && val.customer_code && val.customer_code.length == 12) {
                this.xmlBundleTable(val)
                this.forNextCadRequest(val)
                // this.referenceSite(val)
                // this.referenceShio(val)
                this.getJibanData(val)
                this.getALVSStopCheck(val)
            }

            if(val){
                if(withCheck.test(val.construction_code)){ // if starts with 0009999
                    this.showCheck = true;
                }
                if(defaultWithCheck.test(val.construction_code)){ // if starts with 0009999
                    this.showCheck = true;
                    this.noBossCheckbox = true;
                    this.setAsDefault = true
                }
            }
        },

        "$store.state.editMode"(val){
            // console.log(val,'val')
            if(val){
                var regExp = /[a-zA-Z]/g;
                if(regExp.test(this.$store.state.editCadRequestRevisionContent.revision_number)){
                    let removeLet = this.$store.state.editCadRequestRevisionContent.revision_number.slice(0, -1)
                    this.currentRevision = removeLet
                }else{
                    this.currentRevision = this.$store.state.editCadRequestRevisionContent.revision_number
                }
            }
            else{
                if(val.length > 0){
                    var regExp = /[a-zA-Z]/g;
                    if(regExp.test(val[val.length-1].revision_number)){
                        let removeLet = val[val.length-1].revision_number.slice(0, -1)
                        this.currentRevision = removeLet
                    }else{
                        this.currentRevision = val[val.length-1].revision_number
                    }
                }else{
                    this.currentRevision = '0-0';
                }
            }
        },
        "$store.state.editCadRequestRevisionContent"(val){
            if(val.revision_type){
                if(val.hrd_process == 1){
                    this.radio = "8";
                }else{
                    this.radio = val.revision_type;
                }
                
            }
            if(val.isBossChecked == 1) this.noBossCheckbox = true
            if(val.isHrdCpn == 1 && val.revision_type == '8') this.copyPrev = true
            if(val.isHrdCpn == 1 && val.revision_type == '9') this.copyPrevRetain = true
            // console.log(this.radio, "this.radio")

        },
        "$store.state.existingRevisions"(val){
            // this.getRevisionNumber = val[val.length-1].revision_number.slice(0,1);
            // console.log(val[val.length-1].revision_number.slice(0,1),'revision_number')


            // if(val.length > 0){
            //     if(val[val.length-1].revision_number)
            //     this.currentRevision = val[val.length-1].revision_number
            // }else{
            //     this.currentRevision = '0-0';
            // }


            if(val.length > 0){
                var regExp = /[a-zA-Z]/g;
                if(regExp.test(val[val.length-1].revision_number)){
                    let removeLet = val[val.length-1].revision_number.slice(0, -1)
                    this.currentRevision = removeLet
                }else{
                    this.currentRevision = val[val.length-1].revision_number
                }
            } else{
                this.currentRevision = '0-0';
            }

            this.existingRevisionNumbers = [];
            // GET EXISTING REVISION NUMBERS
            val.filter((r) => {
                this.existingRevisionNumbers.push(r.revision_number)
            })
            this.existingRevisionNumbers = this.existingRevisionNumbers.reverse();

            if(val.length == null){
                this.secondDigit = 1;
            } else {
                this.secondDigit = null;
            }
            // console.log(val,'val')
        },
        radio(val){
            // console.log(val,'vaaaal')
            if(!val) return 
            if(!this.$store.state.editMode){
                this.firstDigit = null
                this.secondDigit = null
                this.copyPrev = false;
                this.copyPrevRetain = false;
                this.$nextTick(() => {
                    if (this.$refs.CustomRevision) {
                        this.radio3 = null
                        this.$refs.CustomRevision.reset();
                    }

                    if (this.$refs.APlan) {
                        this.radio2 = null
                        this.$refs.APlan.reset();
                    }

                    if(this.$refs.ZPlan){
                        this.radio4 = null
                        this.$refs.ZPlan.reset();
                    }
                })

                if(this.radio == '7') {
                    const existingNewRevisions = this.$store.state.existingRevisions;
                    // Find the latest revision where revision_type is equal to '7' or SI selection
                    let getNewLatestIndex = -1;
                    for (let i = existingNewRevisions.length - 1; i >= 0; i--) {
                        if (existingNewRevisions[i].revision_type === '7') {
                            getNewLatestIndex = i;
                            // console.log(getNewLatestIndex,'Latest Index')
                            break;
                        }
                    }

                    if (getNewLatestIndex !== -1) {
                        const latestNewRevision = existingNewRevisions[getNewLatestIndex];
                        const latestNewRevisionNumber = latestNewRevision.revision_number;
                        const revisionNewContent = latestNewRevisionNumber.split('-');
                        this.newSecondDigit = +revisionNewContent[1] + 1;
                        console.log(+revisionNewContent[1]+1,'revisionNewContent')
                        // console.log('Latest valid revision number:', latestNewRevisionNumber);
                    } else {
                        console.log('No valid revisions found');
                    };

                    this.$store.state.attachments = [];
                }
                
            }else{
                let rev = this.$store.state.editCadRequestRevisionContent.revision_number.split("-")
                if(this.radio == "1"){
                    if(this.$store.state.editCadRequestRevisionContent.gravity == 2){
                        this.radio2 = "1A"
                    }else if(this.$store.state.editCadRequestRevisionContent.gravity == 3){
                        this.radio2 = "1B"
                    }
                }else if(this.radio == "5"){
                    this.firstDigit = rev[0];
                    this.secondDigit = rev[1];

                    if(this.radio3 == '5Z'){
                        if(this.$store.state.editCadRequestRevisionContent.gravity == 2){
                            this.radio4 = '5ZA'
                        }else if(this.$store.state.editCadRequestRevisionContent.gravity == 3){
                            this.radio4 = '5ZB'
                        }
                    }

                    if(this.$store.state.editCadRequestRevisionContent.gravity == 1){
                        this.radio3 = "5A"
                    }else if(this.$store.state.editCadRequestRevisionContent.gravity == 2){
                        this.radio3 = "5B"
                    }else if(this.$store.state.editCadRequestRevisionContent.gravity == 3){
                        this.radio3 = "5C"
                    }else if(this.$store.state.editCadRequestRevisionContent.gravity == 0){
                        this.radio3 = '5D'
                    }
                }else if(this.radio == "7"){
                    this.fixedFirstDigit = rev[0];
                    this.newSecondDigit = rev[1];
                    this.secondRadio3 = this.$store.state.editCadRequestRevisionContent.gravity_type;
                    if(this.secondRadio3 == '7Cad'){
                        // this.icad1 = this.$store.state.editCadRequestRevisionContent.gravity
                        if(this.$store.state.editCadRequestRevisionContent.gravity == 2){
                            this.icad1 = "1A"
                        }else if(this.$store.state.editCadRequestRevisionContent.gravity == 3){
                            this.icad1 = "1B"
                        }
                    }else{
                        if(this.$store.state.editCadRequestRevisionContent.gravity == 1){
                            this.secondRadio3 = "5A"
                        }else if(this.$store.state.editCadRequestRevisionContent.gravity == 2){
                            this.secondRadio3 = "5B"
                        }else if(this.$store.state.editCadRequestRevisionContent.gravity == 3){
                            this.secondRadio3 = "5C"
                        }                        
                    }

                }else if(this.radio == "8"){
                    this.revision_hrdProcess = this.$store.state.editCadRequestRevisionContent.revision_number
                    if(/[a-zA-Z]/.test(this.$store.state.editCadRequestRevisionContent.revision_number)){
                        this.copyPrev = false;
                    }else{
                        this.copyPrev = true;
                    }
                }else if(this.radio == "9"){
                    this.revision_CPN = this.$store.state.editCadRequestRevisionContent.revision_number
                    if(this.$store.state.editCadRequestRevisionContent.isHrdCpn == 1){
                        this.copyPrevRetain = true;
                    }else{
                        this.copyPrevRetain = false;
                    }
                }
            }

            // STANDARD REVISION IF PINILI ANG 1ST AND 2ND RADIO
            if(this.radio == '5' && (this.$store.state.kakou_reason == 1 || this.$store.state.kakou_reason == 2) && this.cadRequestBasicInformation.sent_process_request_date != null){
                this.firstDigit = 'S' 
            }

            // FIRST TIME REQUEST IN KAKOUIRAI REASON 1ST AND 2ND RADIO ANG PINILI
            if(this.radio == '5' && this.$store.state.existingRevisions.length-1){
                this.secondDigit = '1';
            } 

            // if(this.radio == '5' && this.$store.state.existingRevisions.length != null){
            //     const kakou = this.$store.state.existingRevisions.revision_number
            //     this.secondDigit = `${parseInt(kakou[1] + 1)}`
            //     console.log(kakou,'this.secondDigits')
            // } 

        },

        dialog(val){
            if(val){
                if(this.$store.state.editMode){
                    let rev = this.$store.state.editCadRequestRevisionContent.revision_number.split("-")
                    if(this.radio == "7"){
                        this.fixedFirstDigit = rev[0];
                        this.newSecondDigit = rev[1];
                    }
                } else {
                    if(this.radio == '7') {
                        const existingNewRevisions = this.$store.state.existingRevisions;
                        // Find the latest revision where revision_type is equal to '7' or SI selection
                        let getNewLatestIndex = -1;
                        for (let i = existingNewRevisions.length - 1; i >= 0; i--) {
                            if (existingNewRevisions[i].revision_type === '7') {
                                getNewLatestIndex = i;
                                break;
                            }
                        }
                        if (getNewLatestIndex !== -1) {
                            const latestNewRevision = existingNewRevisions[getNewLatestIndex];
                            const latestNewRevisionNumber = latestNewRevision.revision_number;
                            const revisionNewContent = latestNewRevisionNumber.split('-');
                            this.newSecondDigit = +revisionNewContent[1] + 1;
                            console.log(+revisionNewContent[1]+1,'revisionNewContent')
                        } else {
                            console.log('No valid revisions found');
                        };
                    }
                }
            }
            // console.log(val,'val')
            // if( !val ){
            //     this.radio = null;
            //     this.radio2 = null;
            //     this.radio3 = null;
            //     this.radio4 = null;
            // }
        }
    }
}
</script>

<style>
.centered-input input {
    text-align: center;
}
</style>
